const translations = {
  language: '简体中文',
  productName: 'AIMfly',
  welcomeMessage: '今天准备写点什么?',
  subscription: {
    modalTitle: '请选择您的升级方案',
    pricingDescription: '灵活的定价方案，满足不同的业务需求',
    cancelAnytime: '随时可取消。订阅即表示您同意 AIMfly 的',
    privacy: '隐私政策',
    terms: '使用条款',
    planType: {
      free: '免费用户',
      starter: 'Starter 用户',
      maker: 'Maker 用户',
      enterprise: '企业用户',
      plus: 'Plus 用户',
    },
    earlyBirdsWelcome: {
      title: '致最早的同行者',
      subtitle: '积分系统上线的第一天，我们最想感谢的，就是你。',
      description1: '感谢你曾在无限时代给予支持。',
      description2: '积分制上线，你无需改变任何使用方式。',
      description3: 'Kimi、GPT-4.1、Gemini等主力模型，仍可无限使用。',
      slogan: '感谢你的信任，愿与你一起走向更远的创作边界！',
      gotIt: '我知道了',
      learnMore: '了解我的无限权限',
    },
    subscriptionManagement: {
      title: '订阅管理',
      subtitle: '管理订阅方案与积分',
      currentPlan: '当前订阅方案',
      willExpire: '到期',
      willAutoRenew: '将自动续订',
      viewBilling: '查看账单',
      changePlan: '变更套餐',
      viewPricing: '查看定价',
      upgradePlan: '升级套餐',
      availableCredits: '总积分',
      remainingCredits: '剩余积分',
      regularCredits: '常规积分',
      templateEarningsCredits: '收益积分',
      availableCreditsDescription: '您可用于运行工作流的积分总数',
      regularCreditsDescription: '通过购买、任务、活动或系统赠送等方式获得的积分',
      templateEarningsCreditsDescription: '他人运行你的模板后获得的积分收益',
      knowledgeBaseFiles: '知识库文件',
      creditUsageDetails: '积分使用明细',
      creditRechargeDetails: '积分获取明细',
      pagination: {
        totalItems: '第 {{start}}-{{end}} 项，共 {{total}} 项',
      },
      usageDetails: '使用详情',
      usageTime: '使用时间',
      creditChange: '积分变更',
      rechargeSource: '获取途径',
      rechargeTime: '获取时间',
      expiryDate: '有效期至',
      remaining: '剩余',
      status: '状态',
      disabled: '已过期',
      usageType: {
        model_call: '模型调用',
        tool_call: '工具调用',
        media_generation: '媒体生成',
        embedding: '向量嵌入',
        reranking: '重排序',
        other: '其他',
        commission: '模板使用',
        commissionPrefix: '模板使用：',
      },
      rechargeType: {
        purchase: '购买积分包',
        gift: '赠送',
        promotion: '促销',
        refund: '退款',
        subscription: '订阅',
        commission: '模板收益',
        commissionPrefix: '模板收益：',
        invitation: '邀请奖励',
      },
      depleted: '已用尽',
      expired: '已失效',
      available: '可用',
      planNames: {
        starter: 'Starter 启程版',
        maker: 'Maker 创造者版',
        freePlan: 'Free 免费版',
        plus: 'Plus',
      },
      creditsWelcome: {
        title: '亲爱的创作者',
        subtitle: 'AIMfly.ai 正式上线积分系统！',
        description1: '您的现有会员权益已完整保留，并将每月自动获得相应积分用于生成内容。',
        description2: '若想体验灵活计费、专属活动，欢迎随时升级新版套餐（享有专属限时双倍积分）！',
        slogan: '感谢一路相伴，新的创作旅程，从积分时代开始！',
        continueButton: '继续使用当前版本',
        learnMoreButton: '了解新套餐',
      },
    },
    yearly: '按年',
    monthly: '按月',
    days: '天',
    monthUnit: '月',
    yearUnit: '年',
    save20: '立减20%',
    mostPopular: '最受欢迎',
    storageExceeded: {
      title: '存储空间已满',
      description:
        '您的存储空间已达到上限。升级您的订阅计划以获得更大的存储空间，继续使用我们的服务。',
      upgrade: '立即升级',
    },
    creditBilling: {
      description: {
        '5k_tokens':
          '每 5k 输入 token 消耗 {{inputCost}} 积分，每 5k 输出 token 消耗 {{outputCost}} 积分',
        '1m_tokens':
          '每 1M 输入 token 消耗 {{inputCost}} 积分，每 1M 输出 token 消耗 {{outputCost}} 积分',
        product: '每个产物消耗 {{cost}} 积分',
        canvasTotal: 'AI 输出不稳定，积分仅为预估情况，需按实际执行结果',
      },
    },
    plans: {
      getStarted: '立即开始',
      memberBenefits: '会员权益',
      free: {
        title: 'Free',
        titleCn: '终身免费',
        description: '开启创意之旅的完美起点',
        price: '永久免费',
        buttonText: '继续免费使用',
        buttonTextDowngrade: '变更为 Free',
        continueUse: '继续免费使用',
        features: ['每日可获取新积分\n100点'],
      },
      pro: {
        title: 'PRO',
      },
      plus: {
        title: 'Starter计划',
        titleCn: 'Plus',
        description: '适合运行高频自动化任务',
        priceMonthly: '$ {{price}}/月',
        priceYearly: '$ {{price}}/月',
        priceYearlyTotal: '$ {{price}}/年 节省 20%',
        buttonText: '升级到 {{planName}}',
        features: ['每日可获取新积分300点', '每月可获取新积分2000点', '可访问庞大的工具库'],
      },
      plus_pro: {
        title: 'Maker计划',
        titleCn: 'Plus Pro',
        description: '适合运行高频自动化任务',
        priceMonthly: '$ {{price}}/月',
        priceYearly: '$ {{price}}/月',
        priceYearlyTotal: '$ {{price}}/年 节省 20%',
        buttonText: '升级到 {{planName}}',
        features: [
          '每日可获取新积分300点',
          '每月可获取新积分2000点',
          '可访问庞大的工具库',
          '服务支持：高级优先级支持',
        ],
      },
      max: {
        title: 'MAX',
      },
      starter: {
        title: 'Starter 启程版',
        titleCn: '启程版',
        description: '轻量探索者的理想选择',
        priceMonthly: '$ {{price}}/月',
        priceYearly: '$ {{price}}/月',
        priceYearlyTotal: '$ {{price}}/年 节省 20%',
        cannotSwitchTo: '无法直接升级到 Plus 套餐。请联系 support@AIMfly.ai',
        buttonText: '升级到 {{planName}}',
        features: [
          '每日可获取新积分\n300点',
          '每月积分\n2000点',
          '世界顶级AI模型\nOpenAI、Claude、Grok、DeepSeek...',
          '知识库文件数\n200个',
          '文件上传限制\n最大 10MB',
          '服务支持\n高优邮件支持',
        ],
      },
      maker: {
        title: 'Maker 创作版',
        titleCn: '创作版',
        description: '进阶创作者的高性能首选',
        priceMonthly: '$ {{price}}/月',
        priceYearly: '$ {{price}}/月',
        priceYearlyTotal: '$ {{price}}/年 节省 20%',
        buttonText: '升级到 {{planName}}',
        features: [
          '每日可获取新积分\n300点',
          '每月积分\n4000点',
          '世界顶级AI模型\nOpenAI、Claude、Grok、DeepSeek...',
          '知识库文件数\n500个',
          '文件上传限制\n最大 20MB',
          '服务支持\n高优邮件支持',
        ],
      },
      enterprise: {
        title: 'Enterprise 企业版',
        titleCn: '企业版',
        description: '专为企业打造的 AI 工作台',
        buttonText: '联系销售咨询',
        contactSales: '联系销售咨询',
        features: [
          '每月享有更多的积分',
          '可视化 Canvas + 节点',
          '多模型集成 + 智能检索',
          '知识库深度连接',
          '模板与节点共享',
          '更多企业级能力敬请期待',
        ],
      },
      currentPlan: '当前套餐',
      priceMonthly: '$ {{price}}/月',
      priceYearly: '$ {{price}}/月',
      priceYearlyTotal: '$ {{price}}/年 节省 20%',
      upgrade: '立即开通',
      cannotChangeTo: '不可变更为 {{planType}}',
    },
    creditPacks: {
      title: '积分包',
      buyNow: '立即购买',
      cancel: '取消',
      credit_pack_100: {
        title: '100积分',
        description: '适合体验高级AI模型',
        price: '$1',
        credits: '100积分',
      },
      credit_pack_500: {
        title: '500积分',
        description: '适合常规AI使用和实验',
        price: '$5',
        credits: '500积分',
      },
      credit_pack_1000: {
        title: '1000积分',
        description: '适合密集AI项目和工作流',
        price: '$10',
        credits: '1000积分',
      },
      credit_pack_2000: {
        title: '2000积分',
        description: '重度AI用户和团队的最佳选择',
        price: '$20',
        credits: '2000积分',
      },
      features: [
        '即时充值\n积分即刻到账，工作不间断。',
        '随处可用\n运行任何工作流、模板、智能体或工具。',
        '90天有效期\n灵活安排积分使用时间。',
        '随时扩展\n适合高负载工作或突发需求。',
      ],
    },
    insufficientCredits: '积分不足',
    buyNow: '立即购买',
    checkoutFailed: '启动支付失败，请重试。',
  },
  voucher: {
    off: '折扣',
    validForDays: '有效期 {{days}} 天',
    popup: {
      congratulations: '恭喜',
      coupon: '优惠券',
      validFor: '有效期 {{days}} 天',
      nonPlusUserDesc1:
        '感谢你贡献如此优秀的模板，我们为你准备了一张 Plus 会员 {{voucherValue}} 折优惠券。',
      nonPlusUserDesc2: '仅需 ${{discountedPrice}} 即可享受完整权益！',
      plusUserDesc1:
        '感谢你贡献如此优秀的模板，我们为你准备了一张 Plus 会员 {{voucherValue}} 折优惠券。',
      plusUserDesc2: '邀请朋友通过你的链接注册并购买会员，你将获得 2000 积分奖励。',
      plusUserReward1: '你：+2,000 额外积分',
      plusUserReward2: '你的朋友：购买会员时享受特别折扣。',
      plusUserClaimedDesc: '你已经是 Plus 会员了，把这张优惠券送给朋友吧！',
      claimedDesc: '升级 AIMfly.ai Plus 会员，畅享 Gemini 3 等高级模型。',
      useNow: '立即使用',
      useCoupon: '使用优惠券',
      shareWithFriend: '分享给朋友',
      publishToGetCoupon: '发布获取优惠券',
      claim: '领取',
    },
    share: {
      posterTitle: '仅需 ${{discountedPrice}}\n即可升级 Plus 会员！',
      posterDesc:
        '使用 {{voucherValue}} 折优惠，升级 AIMfly.ai Plus 会员，畅享完整功能与更高使用上限。',
      ctaText: '加入 AIMfly AI，使用 {{voucherValue}} 折 Plus 优惠券开始体验！',
      validDays: '有效期 7 天。',
      linkCopied: '链接已复制！',
      copied: '已复制',
      copyFailed: '复制失败',
      downloaded: '已下载',
      downloadFailed: '下载失败',
      downloading: '下载中...',
      download: '下载',
      copyLink: '复制链接',
      copyLinkText:
        '解锁 AIMfly.ai 的 vibe-workflow，用 Banana Pro、Gemini 3.0 等顶级 AI 模型为你的自动化工作流加速——${{value}} 折扣助你开启！立即加入 → {{link}}',
      createFailed: '创建邀请失败',
    },
    invite: {
      title: '你收到了礼物！',
      subtitle: '朋友给你分享了一张优惠券',
      off: '折扣',
      forSubscription: '用于订阅',
      validFor: '领取后 7 天内有效',
      claimBtn: '领取优惠券',
      loginToClaim: '登录领取',
      newUser: '还没有账号？',
      signUp: '免费注册',
      invalidTitle: '邀请无效',
      invalidCode: '邀请码无效或已过期',
      invalidDesc: '此邀请链接无效或已过期。',
      verifyError: '验证邀请失败',
      goHome: '返回首页',
      successTitle: '优惠券已领取！',
      successDesc: '优惠券已添加到您的账户，下次订阅时可使用！',
      goWorkspace: '前往工作区',
      usePricing: '立即订阅',
      claimSuccess: '优惠券领取成功！',
      claimError: '领取优惠券失败',
      alreadyClaimed: '优惠码已被领取。发布模板即可获取属于你的优惠券。',
    },
    validation: {
      invalid: '优惠券无法使用：{{reason}}',
    },
  },
  onboarding: {
    rewardTitle: '获得奖励积分',
    rewardPoints: '3000积分',
    startExperience: '立即体验',
  },
  privacyPage: {
    title: '隐私政策',
  },
  termsPage: {
    title: '服务条款',
  },
  form: {
    previous: '← 上一页',
    next: '下一页 →',
    submit: '提交获取积分',
    submitting: '提交中...',
    submitSuccess: '🎉 AIMfly 将推荐最佳模板和任务！',
    pleaseTryAgainLater: '请稍后重试。',
  },
  common: {
    poweredBy: 'Powered by',
    confirm: '确认',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    save: '保存',
    import: '导入',
    saveToCanvas: '添加到画布',
    noData: '暂无数据',
    search: '搜索',
    skip: '跳过',
    finish: '完成',
    add: '添加',
    addSuccess: '添加成功',
    remove: '移除',
    removeSuccess: '移除成功',
    goBack: '返回',
    library: '知识库',
    untitled: '未命名',
    agent: '智能体',
    loading: '加载中...',
    activating: '激活中...',
    loadMore: '加载更多',
    dontShow: '不再展示',
    appStarting: '应用启动中',
    more: '更多',
    putErr: '操作失败，请尝试重试！',
    putSuccess: '操作成功',
    deleteConfirmMessage: '确定删除？',
    multiSelect: '多选',
    input: '输入',
    context: '上下文',
    templateConfig: '模板配置',
    required: '必填项',
    empty: '空空如也',
    selectContext: '选择待使用上下文',
    emptyInput: '内容为空，请填入或选择内容',
    retry: '重试',
    connectionFailed: '连接失败，请重试',
    reset: '重置',
    apply: '应用',
    collapse: '折叠',
    open: '打开',
    close: '关闭',
    canvas: '画布',
    newCanvas: '新画布',
    skillResponse: '技能响应',
    resource: '资源',
    document: '文档',
    newDocument: '新文档',
    docs: '文档',
    skill: '技能',
    thinking: 'AIMfly AI 思考中',
    thread: '会话',
    meta: '元信息',
    project: '知识库',
    upgrade: '升级',
    upgradeSubscription: '升级订阅',
    inviteFriends: '邀请好友，领取奖励积分',
    inviteRewardText: '与好友各得500积分',
    promotion: {
      title: '最低',
      discount: '1折',
      titleSuffix: '拿会员',
      subtitle: '首次发布AI工作流',
      description: '解锁Nano banana pro、Gemini 3.0等全平台顶级模型',
      tag1: '100%获奖',
      tag2: '3000积分',
      button: '立即参与',
    },
    dismiss: '关闭',
    copyRequestInfo: '复制请求信息',
    tryAgain: '重试',
    and: '和',
    copy: {
      title: '复制',
      success: '内容已复制到剪切板！',
      failed: '复制失败，请重试！',
    },
    login: '登录',
    signup: '注册',
    share: '分享',
    dragAndDropFiles: '在此处拖放文件',
    uploadImage: '上传图片',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    upload: {
      notification: {
        uploading: '文件上传中',
        allUploaded: '上传完成！您上传的文件现在可以使用了',
        partialSuccessDesc: '上传完成，成功 {{success}} 个，失败 {{error}} 个',
        allFailed: '文件上传失败',
      },
    },
    errorNotice: {
      resultId: '请求 ID: {{resultId}}',
    },
    dropImageHere: '拖放文件到这里',
    presetColors: '预设颜色',
    duplicate: '副本',
    shareSuccess: '分享链接已复制到剪贴板!',
    shareError: '分享失败，请重试！',
    readonlyWarning: '只读模式',
    readonlyDragDescription: '当前画布为只读模式，不支持修改',
    preview: '预览',
    noContent: '暂无内容',
    noContentDesc: '此页面还没有任何内容',
    wideModeLoadFailed: '宽屏模式加载内容失败',
    returnToList: '返回列表',
    shareLink: '链接分享',
    loadFailed: '加载页面失败',
    loadFailedDesc: '请检查网络连接或稍后再试',
    noPage: '页面不存在',
    noPageDesc: '您查找的页面不存在',
    titlePlaceholder: '输入页面标题',
    descriptionPlaceholder: '输入页面描述（可选）',
    addContent: '添加内容',
    addContentInfo: '添加内容功能即将推出',
    whoCanView: '谁可以查看此页面',
    internetUsers: '互联网获得链接的人',
    notEnabled: '未开启',
    copyShareLink: '复制分享链接',
    shareUrl: '分享链接',
    shareUrlDesc: '获得此链接的人均可查看此页面内容',
    saving: '保存中...',
    savePage: '保存页面',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    shareFailed: '分享失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    copied: '已复制',
    searchNodes: '搜索节点',
    noMatchingNodes: '没有匹配的节点',
    selectedItems: '已选择 {{count}} 项',
    noItemsSelected: '未选择任何项',
    clear: '清除',
    featured: '精选',
    nodesAddedSuccess: '节点添加成功',
    nodesAddedFailed: '节点添加失败',
    canvasIdMissing: '缺少画布ID',
    contentAdded: '内容已添加',
    emptyContent: '暂无内容',
    clickToAdd: '点击添加',
    selectAll: '全选',
    deselectAll: '取消全选',
    addNode: '添加节点',
    viewAll: '查看全部',
    noMore: '已经到底啦',
    action: '操作',
    actions: '操作',
    addedToCanvas: '已添加到画布',
    operationFailed: '操作失败',
    confirmClose: '确认关闭',
    enable: '启用',
    disable: '禁用',
    enabled: '已启用',
    disabled: '已禁用',
    create: '创建',
    update: '更新',
    unknown: '未知',
    validate: '验证',
    refresh: '刷新',
    generating: '生成中...',
    yes: '是',
    no: '否',
    sharing: '分享中...',
    view: '查看',
    joinDiscord: '加入 Discord 社区',
    clipboard: {
      permissionDenied: '剪贴板读取权限被拒绝。请允许剪贴板访问您的浏览器设置。',
      readFailed: '读取剪贴板失败。请重试。',
    },
    loggedOut: {
      title: '已退出登录',
      content: '检测到您在其他标签页退出了登录，点击确定将跳转到登录页面。',
    },
    userChanged: {
      title: '账户已切换',
      content: '检测到您在其他标签页切换了账户，页面将刷新以加载新用户数据。',
    },
  },
  mode: {
    ask: '提问',
    agent: 'Agent',
    askDescription: '问答模式：回答日常问题',
    agentDescription: 'Agent模式：自动规划并执行任务',
    media: '媒体',
    mediaDescription: '媒体模式：生成图片/视频/音频',
  },
  verifyRules: {
    emailRequired: '邮箱地址不能为空',
    emailInvalid: '请输入有效的邮箱地址',
    passwordRequired: '密码不能为空',
    passwordMin: '密码必须包含 8 个或更多字符',
    passwordConfirmNotMatch: '两次输入的密码不一致',
  },
  editor: {
    placeholder: {
      default: "按 '/' 键激活命令",
      title: '请输入标题',
    },
    aiSelector: {
      thinking: 'AI 思考中',
    },
    command: {
      askAi: '问问 AI',
      askAiDescription: '让 AI 帮你写作',
      text: '文本',
      textDescription: '直接输入文本',
      heading1: '标题 1',
      heading1Description: '大标题',
      toDoList: '待办事项',
      toDoListDescription: '使用待办事项记录任务',
      bulletList: '列表',
      bulletListDescription: '创建一个简单的列表',
      quote: '引用',
      quoteDescription: '引用内容',
      code: '代码',
      codeDescription: '代码片段',
      image: '图片',
      imageDescription: '上传图片',
      table: '表格',
      tableDescription: '创建一个表格',
    },
    nodeSelector: {
      text: '文本',
      heading1: '一级标题',
      heading2: '二级标题',
      heading3: '三级标题',
      toDoList: '待办事项',
      bulletList: '列表',
      numberedList: '有序列表',
      quote: '引用',
      code: '代码',
    },
    linkSelector: {
      placeholder: '粘贴链接',
    },
    colorSelector: {
      color: '颜色',
      background: '背景',
      default: '默认',
      purple: '紫色',
      red: '红色',
      yellow: '黄色',
      blue: '蓝色',
      green: '绿色',
      orange: '橙色',
      pink: '粉色',
      gray: '灰色',
    },
    table: {
      addRowBefore: '在上方插入行',
      addRowAfter: '在下方插入行',
      deleteRow: '删除行',
      addColumnBefore: '在左侧插入列',
      addColumnAfter: '在右侧插入列',
      deleteColumn: '删除列',
      deleteTable: '删除表格',
    },
  },
  systemMaintenanceShutdown: {
    title: '尊敬的用户，您好！',
    content:
      '为了提供更加稳定和高效的服务，我们计划在北京时间 21:00 至 23:00 期间对系统进行例行维护。在此期间，虽然您仍可以访问我们的产品页面，但服务将暂时无法使用。我们对由此给您带来的任何不便深表歉意，并感谢您的理解和支持。',
  },
  tabMeta: {
    digestTopics: {
      title: '所有主题',
      description: '基于您的浏览历史、会话历史分析提取出来的主题分类，代表您的阅读和学习趋势',
    },
    threadLibrary: {
      title: '会话库',
    },
    settings: {
      title: '设置',
    },
    skill: {
      title: '技能',
    },
  },
  landingPage: {
    slogan: '全球领先的开源人机协作 Agentic 工作空间',
    description:
      'AIMfly.ai 是一款开源的 Agentic 工作空间，专为人机协作而生。在真实场景中无缝融合人类洞察与 AI 执行力——无论是快速原型设计、精美 PPT 制作、热点话题分析、深度研究流程自动化、多模态营销内容生成，还是复杂业务流程编排，AIMfly 都能为团队提供全链路透明可控的任务驱动体验。',
    anotherDescription:
      'AIMfly.ai 是一款开源的 Agentic 工作空间，专为人机协作而生。在真实场景中无缝融合人类洞察与 AI 执行力——无论是快速原型设计、精美 PPT 制作、热点话题分析、深度研究流程自动化、多模态营销内容生成，还是复杂业务流程编排，AIMfly 都能为团队提供全链路透明可控的任务驱动体验。',
    simplyDescription: {
      first: '由多线程对话、代码组件、知识库集成、上下文记忆和智能搜索驱动，',
      second: 'AIMfly 是将创意转化为优质内容的最佳方式。',
    },
    loginLeft: {
      title: '自动化工作流平台',
      subtitle: '简单而智能的工作流程',
    },
    messageText: '🚀 v0.10.0 发布！这才是智能工作流的新范式',
    simpleMessageText: '🚀 v0.10.0 发布！这才是智能工作流的新范式',
    tryForFree: '开始使用',
    tryItNow: '立即体验',
    creationEngine: '创作引擎',
    addToChrome: '安装浏览器插件',
    contactUs: '联系我们',
    watchVideo: '观看视频',
    joinBtn: '免费使用',
    downloadBtn: '下载插件',
    loginBtn: '登录',
    dashboard: '主页',
    features: {
      tag: '核心功能',
      title: 'AIMfly 的主要功能',
      fileFormats: {
        pdf: {
          name: 'document.pdf',
          body: '专业的 PDF 文档，支持富文本、图片和交互元素，保持一致的格式排版。',
        },
        markdown: {
          name: 'notes.md',
          body: '简洁的 Markdown 文件，用于文档编写、笔记和格式化文本，支持代码块。',
        },
        word: {
          name: 'report.docx',
          body: 'Microsoft Word 文档，具有高级格式设置、修订跟踪和协作编辑功能。',
        },
        html: {
          name: 'webpage.html',
          body: '网页文件，包含结构化内容、样式和交互元素，适用于浏览器查看。',
        },
        epub: {
          name: 'book.epub',
          body: 'EPUB 格式的电子书，支持自适应内容排版、章节和多媒体。',
        },
        jpg: {
          name: 'photo.jpg',
          body: '高质量压缩的照片和图像，适用于网页和打印。',
        },
        gif: {
          name: 'animation.gif',
          body: '动态 GIF 图像，用于短循环动画、表情包和简单动态图形。',
        },
        png: {
          name: 'screenshot.png',
          body: '无损 PNG 图像，支持透明度，适用于 UI 元素和截图。',
        },
      },
      models: {
        deepseekR1: {
          name: 'DeepSeek R1',
          description: '先进的语言理解能力',
          provider: 'DeepSeek',
        },
        o3mini: {
          name: 'o3-mini',
          description: '高级推理和创造力',
          provider: 'OpenAI',
        },
        claude35: {
          name: 'Claude 3.5 Sonnet',
          description: '最适合处理高度复杂任务的模型',
          provider: 'Anthropic',
        },
        claude37: {
          name: 'Claude 3.7 Sonnet',
          description: '最适合处理高度复杂任务的模型',
          provider: 'Anthropic',
        },
        claude37thinking: {
          name: 'Claude 3.7 Sonnet Thinking',
          description: '最先进的推理能力，最适合处理高度复杂任务的模型',
          provider: 'Anthropic',
        },
        gemini2pro: {
          name: 'Gemini Pro 2.0',
          description: '最适合处理高度复杂任务的模型',
          provider: 'Google',
        },
        gemini2flashthinking: {
          name: 'Gemini 2.0 Flash Thinking',
          description: '最先进的推理能力，最适合处理高度复杂任务的模型',
          provider: 'Google',
        },
        gemini: {
          name: 'Gemini Flash 2.0',
          description: '快速高效的日常任务处理',
          provider: 'Google',
        },
        qwen: {
          name: 'Qwen-Max',
          description: '强大的多语言处理能力',
          provider: 'Qwen',
        },
        llama: {
          name: 'Llama 3.3 70B',
          description: '开源基础模型',
          provider: 'Meta',
        },
        mistral: {
          name: 'Mistral 8x7B Instruct',
          description: '高效强大的语言模型',
          provider: 'Mistral',
        },
      },
      featureOne: {
        tag: '多模态支持',
        title: '支持 14+ 文件和图片类型，打造全方位创作体验',
        bulletPoints: [
          '支持 PDF、DOCX、RTF、TXT、MD、HTML、EPUB 等多种文档格式',
          '支持 JPG、PNG、JPEG、WEBP、GIF、TIFF、BMP 等图片格式',
          '智能识别和处理多种文件类型，提供统一的使用体验',
        ],
      },
      featureTwo: {
        tag: '多模型支持',
        title: '集成 13+ 顶尖 AI 模型，满足不同场景需求',
        bulletPoints: [
          '支持 Claude、DeepSeek、Gemini、GPT-4o 等先进模型',
          '提供 Claude Haiku、DeepSeek V3、Llama 等标准模型',
          '根据任务智能推荐最佳模型，确保输出质量',
        ],
      },
      featureThree: {
        tag: '多分支对话',
        title: '灵活的多分支对话与智能上下文选择',
        bulletPoints: [
          '支持对话分支，同时探索多条思维路径',
          '自由选择知识库或画布卡片作为上下文，提升回答质量',
          '智能的上下文记忆，确保不同分支间对话的连贯性',
        ],
      },
      featureFour: {
        tag: '知识库集成',
        title: '具有数据连接器和浏览器扩展的强大知识库管理',
        bulletPoints: [
          '构建个性化知识库，实现知识沉淀与复用',
          '便捷的浏览器插件，一键保存网页内容',
          '智能的知识关联与检索，激发创作灵感',
        ],
      },
      featureFive: {
        tag: '可见即可得的 AI 代码小组件',
        title: '智能的 AI 辅助编辑器， 包括文档、PPT、SVG、HTML、React 等',
        bulletPoints: [
          '实时的 AI 写作建议和润色优化',
          '支持多种写作风格和格式调整',
          '智能的文本分析和改进建议',
          '支持多种代码小组件类型，包括文档、PPT、SVG、HTML、React 等',
        ],
      },
    },
    pricing: {
      title: '计划与定价',
      subtitle: '踏上您的 AI 内容创作之旅',
      description: '一键注册，即刻使用顶级 AI 模型，无需配置，无需信用卡，创作从不设限。',
      limitedOffer: '现在订阅年度计划永久五折！3月16日上午8点（北京时间）调整价格并取消无限套餐',
    },
    footer: {
      cta: {
        title: '准备好立即体验 AI 自由画布，激发创作灵感了吗？',
        getStarted: '立即体验',
        contactUs: '联系我们',
      },
      description:
        '快速总结与形成洞察、自动化归档以及智能语义搜索——AIMfly 能够为你打造第二大脑，拓展你的知识视野，并赋予你超乎寻常的能力。',
      right: 'AIMfly.ai 版权所有。',
      product: {
        title: '产品',
        list: ['自由画布', '多线程会话', '知识库集成', '上下文记忆', '智能检索', 'AI 文档'],
      },
      resource: {
        title: '资源',
        twitter: '推特',
        github: 'GitHub',
        discord: 'Discord',
        docs: '文档',
      },
      about: {
        title: '关于',
        privacy: '隐私政策',
        terms: '服务条款',
      },
      navigation: {
        homepage: '首页',
        docs: '文档',
        guides: '指南',
        contactUs: '联系我们',
      },
      copyright: '© 2025 Powerformer, Inc. 版权所有',
      contactUs: {
        title: '联系我们',
        community: '社区',
        mail: '邮箱',
        joinGroup: '加入用户交流群',
        scanToJoinWechatGroup: '扫码加入微信交流群',
        orWeChat: '或微信',
        discordGroup: 'Discord 交流群',
        notionDocument: '文档',
        viewDocument: '查看文档',
        feishuDocument: '飞书文档',
        joinDiscordGroup: '加入 Discord',
        followAIMflyUpdates: '关注 AIMfly 动态',
        AIMflyTwitterAccount: 'AIMfly官方账号',
      },
      platforms: {
        title: '平台',
        chrome: 'Chrome 插件',
        web: 'Web 应用',
      },
    },
    loginFailed: {
      title: '登录失败',
      content: '登录失败，请重新登录',
    },
    loginModal: {
      continue: '继续',
      signin: '登录',
      signup: '注册',
      greeting: {
        signin: '请登录你的账号！',
        signup: '请注册你的账号！',
        signinSubtitle: '请登录以继续使用',
        signupSubtitle: '请填写详细信息以开始使用',
      },
      signinTitle: '登录 AIMfly',
      signinSubtitle: '请登录以继续使用',
      signupTitle: '创建您的账户',
      signupSubtitle: '请填写详细信息以开始使用',
      signinHint: '已有账户？',
      signupHint: '还没有账户？',
      oauthBtn: {
        github: '通过 Github 登录',
        google: '通过 Google 登录',
      },
      emailLabel: '邮箱地址',
      emailPlaceholder: '请输入邮箱',
      passwordLabel: '密码',
      passwordPlaceholder: '请输入密码',
      passwordForget: '忘记密码？',
      loggingStatus: '登录中...',
      and: '及',
      utilText: '注册即表明您同意 ',
      privacyPolicy: '隐私政策',
      terms: '服务条款',
      or: '或使用邮箱登录',
      readAndAgree: '阅读并同意',
      userPrivacyPolicy: '《用户隐私条款》',
      accountLogin: '账号登录',
      accountSignup: '账号注册',
    },
    resetPasswordModal: {
      title: '重置密码',
      continue: '继续',
      emailLabel: '邮箱地址',
      emailPlaceholder: '请输入您的邮箱地址',
      passwordLabel: '新密码',
      passwordPlaceholder: '请输入您的新密码',
      passwordConfirmLabel: '确认密码',
      passwordConfirmPlaceholder: '请再次输入您的新密码',
    },
    tab: {
      home: '首页',
      product: '产品',
      price: '价格',
      docs: '文档',
      videoTutorials: '视频教程',
      discord: 'Discord',
      priceTag: '五折',
      community: '用户交流群',
      wechat: '微信',
      gallery: '用例',
      useCases: '画布用例',
      artifacts: '作品用例',
    },
    faq: {
      title: '常见问题',
      Q1: 'AIMfly 可以免费使用吗？',
      A1: 'AIMfly 作为开源项目，对于个人用户，您可以通过自行部署社区版使用其所有功能。为了更多用户快速上手体验 AIMfly，我们为所有注册用户提供 100 个知识库文件存储额度，以及每天 5 次 T1 模型调用和 50 次 T2 模型调用。如果您需要体验进阶模型或扩大用量，可升级付费订阅套餐。',
      Q2: '你们支持哪些付款方式？',
      A2: '我们支持银行卡、支付宝、Amazon Pay 和 Cash App Pay。支持的付款方式可能随时有变，请以 Stripe 收银台显示的付款方式为准。',
      Q3: '如何更改或取消订阅方案？',
      A3: '如需升级或降级订阅方案，请联系 AIMfly 团队为您处理。如果需要取消订阅方案，请点击「设置-订阅-管理账单及订阅」按钮后前往 Stripe 管理订阅计划。取消订阅成功后，在当前方案到期时将自动降级为免费版。',
      Q4: '是否支持退款？',
      A4: '目前暂不开放退款入口，如果您有强烈的退款需求，请联系 AIMfly 团队为您解决。',
      Q5: '作为 AIMfly 的用户，我的数据存储在哪里？',
      A5: '如果您使用的是 AIMfly Cloud 服务，数据均安全存储在美国。如果您选择自行部署，则数据存储于您部署 AIMfly 的机器。我们不会收集任何自行部署 AIMfly 服务的数据。',
      Q6: '我能否在企业内部私有化部署 AIMfly？',
      A6: '在企业内部私有化部署 AIMfly 需要购买商业许可证，请电函 support@AIMfly.ai 联系我们进行沟通。',
    },
    workflow: {
      tag: '工作流',
      title: 'AIMfly 的',
      workflowOne: {
        tag: '规划',
        title: '在自由画布中梳理思路，让专业创作从混沌到有序',
        bulletPoints: [
          '覆盖学术研究、技术文档等 20+ 专业场景模板',
          'AI 协助分析主题，智能构建研究框架',
          '基于个人知识库持续积累，建立深度思维链接',
        ],
      },
      workflowTwo: {
        tag: '探索与导入',
        title: '打通知识壁垒，让零散资料化为创作养分',
        bulletPoints: [
          '一键导入论文、网页等多源专业资料',
          'AI 智能检索，快速定位核心参考内容',
          '自动建立知识关联，激发跨领域洞见',
        ],
      },
      workflowThree: {
        tag: '研究',
        title: '多线程对话激发思维，让研究过程更富启发',
        bulletPoints: [
          '在画布中自由发散对话，深入探索观点',
          '智能上下文管理，确保研究方向精准',
          '灵活调用知识库，加速研究突破',
        ],
      },
      workflowFour: {
        tag: '思考与创作',
        title: '从构思到成稿，让专业创作更具洞察力',
        bulletPoints: [
          '自由选择上下文，打造个性化写作环境',
          'N+ 专业写作辅助工具，提升学术/技术写作效率',
          'AI 编辑助手，确保专业输出质量',
          '支持多种代码小组件类型，包括文档、PPT、SVG、HTML、React 等',
        ],
      },
      workflowFive: {
        tag: '剪存',
        title: '一键剪存任意网页内容，持续打造第二大脑',
        bulletPoints: [
          '一键保存任意网页内容（Twitter、小红书、Notion 等）',
          '支持私有网页内容剪存与整理',
          '持续积累个人知识库',
          '无缝集成到第二大脑',
        ],
      },
    },
  },
  priceContent: {
    freeCapabilities: [
      {
        before: '基于',
        highlight: '多线程会话',
        after: '的自由画布，任意组合上下文进行提问',
      },
      {
        before: '',
        highlight: '基础模型',
        after: '驱动的强大技能：生成文档、推荐问题、全网搜索、知识库搜索',
      },
      {
        before: '通过全网搜索、文件上传或任意粘贴链接导入资源，构建',
        highlight: '有限大小',
        after: '的个人知识库',
      },
      {
        before: '借助',
        highlight: '基础模型',
        after: '驱动的 AI Markdown 编辑器',
      },
      {
        before: '借助',
        highlight: '基础模型',
        after: '驱动的 PPT，SVG，可视化网页、表格和 Mermaid 图表生成',
      },
    ],
    premiumCapabilities: [
      {
        before: '基于',
        highlight: '多线程会话',
        after: '的自由画布，任意组合上下文进行提问',
      },
      {
        before: '',
        highlight: '先进模型',
        after: '驱动的强大技能：生成文档、推荐问题、全网搜索、知识库搜索',
      },
      {
        before: '通过全网搜索、文件上传或任意粘贴链接导入资源，构建',
        highlight: '庞大',
        after: '的个人知识库',
      },
      {
        before: '借助',
        highlight: '先进模型',
        after: '驱动的 AI Markdown 编辑器',
      },
      {
        before: '借助',
        highlight: '先进模型',
        after: '驱动的 PPT，SVG，可视化网页、表格和 Mermaid 图表生成',
      },
    ],
  },
  frontPage: {
    guide: {
      title: '5分钟上手',
      description: '教程学会如何构建一个AI 驱动的工作流',
      view: '去了解',
    },
    newWorkflow: {
      title: '新建',
      buttonText: '新建工作流',
      buttonDescription: '新建空白工作流',
    },
    tutorial: {
      title: '教程',
      buttonText: '5分钟上手教程',
      buttonDescription: '如何构建一个AI 驱动的工作流',
    },
    recentWorkflows: {
      title: '近期工作流',
      edit: '编辑',
      more: '更多',
    },
    template: {
      title: '模板市场',
      endMessage: {
        title: '没有找到你需要的工作流自动化模板？',
        subtitle: '加入我们的 Discord 社区，告诉我们你想要什么',
        goToMarketplace: '探索更多模板',
      },
    },
    agentInputPlaceholder: '输入任务描述，Agent 将生成可复用的工作流',
    chatInputPlaceholder: '输入一个任务，支持选择模型和工具',
    githubStar: '在 GitHub 为我们点 Star!',
    fromCommunity: '来自社区',
    fromCommunityDesc: '探索将 AIMfly 用于工作或更广泛领域的途径。',
  },
  templateMarket: {
    featured: '精选推荐',
    allTemplates: '所有模版',
    searchPlaceholder: '搜索模版素材',
    noData: '暂无模板数据',
    loading: '加载中...',
    perTime: '/次',
    allCategories: '全部分类',
  },
  emailVerification: {
    title: '邮箱验证',
    description: '请输入我们向 {{email}} 发送的验证码:',
    resendHint: '无法收到邮件？',
    resend: '重新发送',
    resendSuccess: '验证邮件发送成功',
    submit: '提交',
  },
  share: {
    keyFeatures: {
      multiThreadedConversation: '多线程对话',
      multiModelIntegration: '多模型集成',
      multiModalProcessing: '多模态处理',
      aiPoweredSkillSystem: 'AI驱动的技能系统',
      knowledgeBaseEngine: '知识库引擎',
      intelligentContentCapture: '智能内容采集',
      aiEnhancedEditor: 'AI增强编辑器',
    },
  },
  shareContent: {
    title: '分享',
    login: '开始用 AIMfly 写作',
    updateShare: '同步',
    updateShareTooltip: '同步最新分享内容',
    updateShareSuccess: '最新画布内容已同步分享',
    copyLink: '复制链接',
    copy: '复制',
    linkCopied: '链接已复制',
    copyLinkTooltip: '复制分享链接',
    publishTemplate: '发布为模版',
    updateTemplate: '更新模板',
    publish: '发布',
    publishTemplateTooltip: '将画布发布为模板',
    waitForAgentsToFinish: '请等待所有 Agent 运行结束后再发布',
    noSkillResponseNodes: '请先在画布中添加 Agent 节点后再发布',
    latestPublishedApp: '最新发布的应用',
    linkShare: '链接分享',
    updateCanvasPermissionSuccess: '更新画布权限成功',
    copyLinkSuccess: '分享链接已复制到剪贴板！',
    accessOptions: {
      anyone: '公开访问',
      anyoneDescription: '获取访问链接的用户可访问',
      off: '仅限自己',
      offDescription: '通过链接访问仅自己可见',
    },
  },
  workspace: {
    addToCanvas: '添加到画布',
    noCanvasSelected: '请先创建或选择一个画布',
    exporting: '正在导出文档...',
    exportSuccess: '文档导出成功',
    exportFailed: '文档导出失败',
    exportAs: '导出为',
    exportDocumentToMarkdown: 'Markdown 文档 (.md)',
    exportDocumentToDocx: 'Word 文档 (.docx)',
    exportDocumentToPdf: 'PDF 文档 (.pdf)',
    openWebpage: '打开原网页',
    downloadFile: '下载文件',
    canvasListModal: {
      continue: '继续对话',
    },
    labelGroup: {
      addLabel: '点击添加标签',
      addLabelTitle: '添加标签',
      getLabelFailed: '获取标签失败',
      deleteConfirmText: '确认删除该标签吗?',
      deleteFailed: '标签删除失败',
      deleteSuccessful: '标签删除成功',
    },
    newProjectModal: {
      modalTitle: '新增项目',
      editModalTitle: '编辑项目',
      titlePlaceholder: '请输入项目标题',
      title: '标题',
      description: '描述',
      descriptionPlaceholder: '请输入项目描述',
      cancel: '取消',
      confirm: '确认',
      successful: '创建成功',
      failed: '创建失败',
      editSuccessful: '修改成功',
      editFailed: '修改失败',
    },
    newLabelModal: {
      modalTitle: '新增标签',
      labelClass: '标签类',
      labelClassPlaceholder: '请选择标签类',
      labelClassValidateMessage: '标签类不能为空',
      valueList: '标签',
      valueListPlaceholder: '输入标签，回车可添加多个',
      valueListValidateMessage: '至少输入一个标签',
      title: '标题',
      cancel: '取消',
      confirm: '确认',
      successful: '创建成功',
      failed: '创建失败',
      editSuccessful: '修改成功',
      editFailed: '修改失败',
    },
    deleteDropdownMenu: {
      successful: '删除成功！',
      unbindSuccessful: '移除成功！',
      failed: '删除失败！',
      deleteConfirmForDocument: '确定删除该文档吗？',
      deleteConfirmForCanvas: '工作流 {{canvas}} 及其中的所有文件将被永久删除，是否继续？',
      deleteConfirmForProject: '确定删除该项目吗？',
      deleteConfirmForResource: '确定删除该资源吗？',
      deleteConfirmForResourceProject: '确认要从项目移除吗?',
      delete: '删除',
      edit: '编辑',
    },
    canvasMaterial: {
      Button: '保存到素材库',
      Title: '保存素材',
      class: '画布素材分类',
      materials: '素材',
      TreeSelectRequired: '请选择画布素材分类',
      materialsRequired: '请选择素材',
      selectAll: '全选',
      download: '下载',
      downloadMaterial: '下载素材',
      creations: '我的创作',
      uploads: '我的上传',
      cancelSelect: '取消全选',
      submit: '保存至素材库',
      cancel: '取消',
    },
  },
  knowledgeBase: {
    directory: {
      canvasCount: '{{count}} 篇画布',
      resourceCount: '{{count}} 篇资源',
      resourcesSearchPlaceholder: '搜索资源...',
      canvasesSearchPlaceholder: '搜索画布...',
      conversationsSearchPlaceholder: '搜索会话...',
    },
    quickSearch: {
      suggest: '建议',
      new: '创建新 {{domain}}',
    },
    note: {
      connecting: '连接中...',
      newNote: '创建新画布',
      noteCharsCount: '共 {{count}} 字',
      autoSaved: '已自动保存',
      saving: '保存中...',
      readOnly: '文档已设为只读状态',
      edit: '文档已设为可编辑状态',
      serviceDisconnected: '服务已断开',
      createNoteFailed: '创建文档失败，请重试！',
      defaultTitle: '未命名',
    },
    canvas: {
      editor: {
        placeholder: {
          default: "按 '/' 键激活命令",
          heading: '标题 {{level}}',
        },
        toolbar: {
          quote: '引用内容提问',
          createMemo: '创建备忘录',
        },
      },
      leavePageModal: {
        title: '确认离开当前画布吗？',
        content: 'AI 仍在写作中，退出页面会导致内容丢失，是否确认离开？',
      },
    },
    context: {
      contentSelectorAddSuccess: '添加成功',
      contentSelectorIsEmpty: '请选择文本',
      contentSelector: '内容划线选择器',
      addContext: '添加上下文',
      createMemo: '创建备忘录',
      createAskAI: '问问 AI',
      createAskAISuccess: '已成功创建问问 AI 节点',
      clearContext: '清空',
      addToContext: '引用提问',
      resource: '资源',
      resources: '资源',
      canvas: '画布',
      canvases: '画布',
      projects: '项目',
      project: '项目',
      contentList: '内容列表',
      extensionWeblink: '网页',
      extensionWeblinkSelection: '网页选中',
      documentSelection: '文档选中',
      resourceSelection: '资源选中',
      documentCursorSelection: '文档光标选中内容',
      documentBeforeCursorSelection: '文档光标前内容',
      documentAfterCursorSelection: '文档光标后内容',
      contextLimitTipTitle: '请调整上下文后重试',
      contextRequiredTip: '至少选择 1 个{{type}}',
      contextLimitTip: '最多可选择{{limit}}个{{type}}，当前已选择{{currentCount}}个',
      popoverSelector: {
        webPlaceholder: '搜索画布、资源或项目...',
        extensionPlaceholder: '搜索网页、画布、资源或项目...',
        footer: {
          navigate: '导航',
          toggle: '切换',
          done: '完成',
          position: '定位',
        },
      },
      contextFilter: {
        acitveBtnTitle: '上下文过滤',
        selectType: '选择类型',
        limitCount: '限制数量',
        apply: '应用',
        contentListSelectedType: '配置选中内容类型',
        contentListSelectedTypeRequired: '请配置选中内容类型',
        contentListLimit: '选中内容数量',
        filterConditions: '过滤条件',
        reset: '重置',
        collapse: '折叠',
        result: '结果',
        empty: '未命中过滤条件',
      },
      alreadyAddedWithTitle: '已添加到上下文',
      addSuccessWithTitle: '已成功添加到上下文',
      addToContextSuccess: '已成功添加到上下文',
      untitled: '未命名',
      deleteSuccessWithTitle: '已成功删除{{type}}节点',
      panelColor: '面板颜色',
      memoPlaceholder: '记录当下的灵感...',
      noContent: '没有可插入的内容',
      noEditor: '没有打开的文档',
      noActiveDocument: '没有打开的文档',
      insertSuccess: '内容插入成功',
      replaceSuccess: '内容替换成功',
      createNoteSuccess: '新建笔记成功',
    },
  },
  document: {
    share: '分享文档',
    setReadOnly: '设置为只读',
    enableEdit: '启用编辑',
    shareLoading: '正在加载共享文档...',
    notFound: '文档未找到',
    notFoundDesc: '您查找的文档不存在或已被删除。',
    tableOfContents: '目录',
    noHeadings: '未找到标题',
    sharing: '正在分享文档...',
    shareSuccess: '文档分享成功！链接已复制到剪贴板。',
    shareError: '分享文档失败',
  },
  driveFile: {
    sharing: '正在分享文件...',
    shareSuccess: '文件分享成功！链接已复制到剪贴板。',
    shareLoading: '正在加载共享文件...',
    fileNoContent: '文件没有内容。',
    notFound: '文件未找到',
    notFoundDesc: '您查找的文件不存在或已被删除。',
  },
  artifact: {
    generating: '生成中',
    completed: '已完成',
    openComponent: '点击打开组件',
    contentTitle: '画布内容',
    loadingContent: '加载内容中...',
    thinking: '思考中...',
    loading: '代码组件加载中...',
    componentNotFound: '代码组件不存在',
    svg: {
      downloadAsSvg: '下载为 SVG',
      downloadAsPng: '下载为 PNG',
      copyToClipboard: '复制 PNG 到剪贴板',
      downloadStarted: '开始下载...',
      downloadSuccess: '下载成功',
      downloadError:
        '下载失败！小组件内未包含 SVG 内容，请选择正确的展示类型，或者检查源文件代码是否完整',
      copyStarted: '开始复制...',
      copySuccess: '已复制到剪贴板',
      copyError: '复制失败',
    },
    fixCodeNeeded: '需要修复代码',
  },
  resourceType: {
    weblink: '网页链接',
    text: '粘贴文本',
    file: '文件',
  },
  canvas: {
    emptyText: '双击画布打开菜单',
    shareNotFound: '画布不存在',
    shareNotFoundHint: '你尝试访问的共享画布无法找到。它可能已被删除，或者链接可能有误。',
    frontPageWelcome: '今天我能为您完成什么工作？',
    nodeTypes: {
      document: '文档',
      resource: '资源',
      skillResponse: '技能响应',
      memo: '备忘录',
      skill: '技能',
      image: '图片',
      codeArtifact: '代码组件',
      website: '网站',
      mindMap: '思维导图',
      group: '分组',
      mediaSkill: '媒体技能',
      mediaSkillResponse: '媒体技能响应',
      video: '视频',
      audio: '音频',
      start: '输入项',
      agent: '智能体',
      documentSelection: '文档选中内容',
      resourceSelection: '资源选中内容',
      skillResponseSelection: '技能响应选中内容',
      extensionWeblinkSelection: '网页选中内容',
      documentCursorSelection: '文档光标选中内容',
      documentBeforeCursorSelection: '文档光标前内容',
      documentAfterCursorSelection: '文档光标后内容',
    },
    export: {
      success: '导出图片成功',
      error: '导出图片失败',
      noNodes: '画布为空，无法导出图片',
    },
    cycleDetectionError: '工作流暂不支持闭环连线，请检查连线方向',
    launchpad: {
      placeholder: '描述你的需求...',
      chatInputPlaceholder: '输入任务描述，Agent 将生成可复用的工作流',
      commonChatInputPlaceholder: '输入任务，@ 可以快速选择用户输入、工具、文件和智能体',
      actionIsRunning: '当前提问正在处理中，请等待完成后再次发送',
    },
    toolbar: {
      searchNode: '搜索节点',
      searchNodeDescription: '搜索画布中的节点，点击节点进行定位。',
      enablePointerMode: '启用框选模式',
      disablePointerMode: '关闭框选模式',
      deleteCanvas: '删除工作流',
      importResource: '导入资源',
      importResourceDescription:
        '通过在线搜索、手动添加网页链接或文本的方式批量添加写作素材在画布中阅读或消费。',
      addResource: '添加资源',
      addResourceDescription:
        '从外部导入或上传的任意内容（例如网页、文件、图片等），可在任意多个画布中被按需消费与使用',
      addSkill: '添加技能',
      addTool: '添加工具',
      autoLayout: '自动布局',
      autoName: '自动命名',
      askAI: '添加自定义Agent',
      imageGeneration: '图片生成',
      videoGeneration: '视频生成',
      audioGeneration: '音频生成',
      mediaGenerate: '多模态生成',
      askAIDescription:
        '通过 AI 提问，可以选择上下文、切换技能或模型，以获取写作灵感、内容创作、知识问答等。',
      createMemo: '添加注释',
      createMemoDescription: '创建备忘录，用于记录灵感、想法、灵感等。',
      addMemo: '添加注释',
      createDocument: '新建文档',
      createDocumentDescription: '创建一篇文档以用于写作。',
      createCodeArtifact: '创建代码组件',
      createCodeArtifactDescription: '创建一个空白代码组件用于编写您的代码',
      addDocument: '添加文档',
      addDocumentDescription:
        '用户在 AIMfly 中创建的内容，通过 AI 写作创建，或手动创建新文档，可以通过 AI 知识库搜索问答。',
      addHighlight: '添加 Highlight',
      hidePreview: '隐藏节点预览',
      showPreview: '显示节点预览',
      togglePreviewDescription: '当在有预览卡片存在时，展示或隐藏画布右侧的预览卡片。',
      hideEdges: '隐藏连线',
      showEdges: '显示连线',
      toggleEdgeTitle: '切换连线状态',
      hideMaxRatio: '取消预览最大比例',
      showMaxRatio: '使用预览最大比例',
      toggleMaxRatioDescription: '当有预览卡片存在时，控制预览卡片可以展示在画布中的比例大小。',
      hideLaunchpad: '隐藏 AI 提问框',
      showLaunchpad: '显示 AI 提问框',
      toggleLaunchpadTitle: '切换 AI 提问框展示状态',
      editTitle: '编辑画布标题',
      editTitlePlaceholder: '请输入画布标题',
      rename: '重命名',
      duplicate: '复制',
      syncingChanges: '同步中',
      synced: '上次同步于{{time}}',
      mouse: '鼠标模式',
      touchpad: '触控板模式',
      tooltip: {
        undo: '撤销',
        redo: '重做',
        initializeWorkflow: '调试',
        initializeWorkflowInNewCanvas: '初始化工作流到新画布',
        zoom: '缩放百分比',
        zoomReset: '重置',
        zoomIn: '放大',
        zoomOut: '缩小',
        fitView: '适应画布',
        layout: '自动布局',
        mode: '交互模式',
        help: '帮助与文档',
        resourceLibrary: '导入文件',
        toolDependencies: '依赖',
        duplicateWorkflow: '复制工作流',
        addUserInput: '新建输入项',
        addNote: '记录灵感',
        previewWorkflowRun: '预览',
        addAgent: '智能体',
      },
      openDocs: '帮助文档',
      openTour: '功能亮点',
      openSettings: '设置向导',
      videoLoading: '视频加载中...',
      deleteCanvasFile: '同时删除工作流中的资源和文档',
      hideTemplates: '隐藏模板',
      showTemplates: '显示模板',
      exportImage: '导出图片',
      exportCanvas: '导出画布',
      slideshow: '幻灯片',
      copyLink: '复制链接',
      createWebsite: '创建网站节点',
      createWebsiteDescription: '创建一个网站节点以在画布中嵌入网站',
      createMindMap: '创建思维导图节点',
      createMindMapDescription: '创建一个思维导图节点以在画布中嵌入思维导图',
      removeFromProject: '从知识库移除',
      openResourcesPanel: '打开资源库',
      closeResourcesPanel: '收起',
      modeChangeSuccess: {
        mouse: '已切换为鼠标模式',
        touchpad: '已切换为触控板模式',
      },
      backDashboard: '回到工作台',
      backHome: '回到首页',
    },
    mediaGeneration: {
      prompt: '提示词',
      model: '生成模型',
      selectModel: '选择生成模型',
      tip: '工作流执行时将根据提示词生成媒体内容',
      videoPromptPlaceholder: '描述你想要生成的视频内容...',
      imagePromptPlaceholder: '描述你想要生成的图片内容...',
      audioPromptPlaceholder: '描述你想要生成的音频内容...',
    },
    workflow: {
      variables: {
        title: 'Text 类型',
        tooltip: '用户输入',
        addTitle: '新建输入项',
        editTitle: '编辑输入项',
        addVariableTitle: '新建{{type}}输入项',
        editVariableTitle: '编辑{{type}}输入项',
        name: '名称',
        value: '内容',
        description: '描述（可选）',
        namePlaceholder: '例如：userName',
        valuePlaceholder: '例如：张三',
        descriptionPlaceholder: '例如：工作流中的用户姓名',
        nameRequired: '名称是必填项',
        valueRequired: '请在运行前将该必填输入项补充完整',
        namePattern: '无效的名称格式',
        duplicateName: '名称已存在',
        loadError: '加载输入项失败',
        saveError: '保存输入项失败',
        saveSuccess: '输入项保存成功',
        updateSuccess: '输入项更新成功',
        deleteUserInput: '删除 {{value}}',
        deleteConfirm:
          '删除后，使用该输入项的智能体会同步失去对应输入，可能影响运行结果。确认删除吗？',
        empty: '暂未定义输入项',
        addVariable: '点击新建',
        variableType: '输入项类型',
        required: '必填',
        multiple: '多选设置',
        singleSelect: '单选',
        multipleSelect: '多选',
        resourceAcceptType: '支持的资源类型',
        resourceTypesRequired: '请选择支持的资源类型',
        selectResourceTypes: '选择资源类型',
        resourceType: {
          document: '文档',
          image: '图片',
          audio: '音频',
          video: '视频',
        },
        resourceValuePlaceholder: '选择资源',
        variableTypeOptions: {
          string: '文本',
          resource: '素材',
          option: '账号',
        },
        string: '文字信息',
        resource: '添加素材',
        option: '添加账号',
        selectMode: '选择模式',
        options: '可选项',
        optionsRequired: '至少需要一个可选项',
        optionsEmpty: '可选项不能为空',
        addOption: '添加可选项',
        maxOptions: '最多可添加{{max}}个可选项',
        selectOptions: '选择可选项',
        clickToEdit: '点击编辑',
        deleteSuccess: '输入项删除成功',
        thisFieldIsRequired: '此字段为必填项',
        uploadBeforeRunning: '运行 Agent 前请先上传文件。',
        inputPlaceholder: '请输入',
        selectPlaceholder: '请选择',
        uploadPlaceholder: '请上传',
        duplicateOption: '可选项不能存在重复值',
        upload: '上传文件',
        typeLimitReached: '{{type}}类型的输入项数量已达上限，无法提交。',
        fileRequired: '请上传一个文件',
        selectValuePlaceholder: '请选择一个可选项',
        startNode: '起始节点',
        resourceLibrary: '资源库',
        viewAndEdit: '查看',
        acceptResourceTypes: '支持的资源类型：',
        fileSizeLimit: '文件大小 ≤ {{size}}MB',
        unsupportedFileType: '不支持的文件类型：{{type}}',
        replaceFile: '替换文件',
        duplicateFileName: '相同文件名已存在，请替换文件',
        tooManyFiles: '最多可上传{{max}}个文件',
        optionSelectedDeleteTooltip: '该选项已被选中作为输入项内容，暂时无法删除',
        optionSelectedEditTooltip: '该选项已被选中作为输入项内容，暂时无法编辑',
        stringAdd: '添加',
        stringAddDescription: '如攻略的地点、时间等信息',
        resourceAdd: '上传',
        resourceAddDescription: '如图片、文档、视频、音频',
        optionAdd: '选项',
        optionAddDescription: '如单选、多选项目',
        selectCategory: '选择分类',
        selectCategoryPlaceholder: '请选择分类',
        selectFiles: '选择文件',
        selectedCount: '已选 {{count}} 个',
        noFiles: '暂无文件',
        selectCategoryFirst: '请先选择分类',
        selectFileFirst: '请先选择文件',
        allFiles: '全部文件',
        selectAll: '全选',
        uploadNewMaterial: '上传新素材',
        uploadToUncategorizedHint: '新上传的素材将归入「未分类」',
        selectOrUploadFirst: '请选择或上传素材',
        uncategorized: '未分类',
        selectAccountCategory: '选择账号分类',
        selectAccounts: '选择账号',
        noAccounts: '暂无账号',
        selectAccountCategoryFirst: '请先选择账号分类',
        allAccounts: '全部账号',
        selectAccountFirst: '请先选择账号',
      },
      userInput: '用户输入',
      run: {
        title: '运行调试',
        run: '立即运行',
        startRunning: '工作流开始运行',
        executing: '运行中',
        remix: '再创作',
        runTooltip: '完成首次体验，解锁Plus会员折扣',
        copyWorkflow: '再创作工作流',
        copyShareLink: '复制分享链接',
        shareLinkCopied: '分享链接已复制到剪贴板',
        shareLinkCopyFailed: '复制分享链接失败',
        emptyTitle: '当前暂无变量',
        emptyDescription: '点击"运行"，Workflow 将被执行一次',
        completed: 'Workflow 运行完成',
        failed: 'Workflow 运行失败',
        executionFailed: '执行失败',
        error: 'Workflow 运行状态时出错',
        validationError: '请填写所有必填字段后再运行工作流',
        installToolsBeforeRunning: '请先安装所需工具后再运行工作流',
        emptyPromptsError: '部分 Agent 尚未填写提示词，无法运行',
        requiredFileInputsMissing: '此智能体包含必填的文件输入项，请先上传所需文件后再运行。',
        requiredFileInputsMissingForChain:
          '当前步骤或后续步骤存在必填的文件输入项未填写，请先上传所需文件后再运行。',
        toolsGuide: '请点击「运行」即可体验，紫色部分支持修改输入内容',
        nodeStatus: {
          waiting: '等待中',
          executing: '运行中',
          finish: '完成',
          failed: '运行失败',
          title: 'Agent 节点状态检查',
          issues: '个问题',
          notRun: '节点未运行',
          unknown: '状态未知',
          locate: '去定位',
          hint: '点击"定位"按钮可以快速跳转到对应节点。',
        },
        creditUsage: '预计使用 {{count}} 积分',
        abort: {
          confirmTitle: '终止工作流执行',
          main: '确认终止工作流执行吗？',
          note: '工作流将立即停止。已完成的步骤将保留，已消耗的积分将不会返还。',
          confirm: '确定终止',
          abortButton: '终止',
          success: '工作流已成功终止。',
          failed: '终止工作流失败',
        },
        forbiddenToAddNodeWhenWorkflowIsRunning: '工作流正在运行中，无法添加节点，请稍后再试',
        noArtifacts: '未找到产物',
        noNodes: '未找到智能体响应节点',
        defaultAgentTitle: '智能体',
        addToFileLibrarySuccess: '已成功添加到文件库',
        preview: '预览',
        outputsOnly: '仅产物',
        inputPanelTitle: '用户输入',
      },
      template: {
        updating: '模板正在发布中...',
      },
    },
    connectionTimeout: {
      title: '连接超时',
      extra: '似乎无法连接到 AIMfly 服务器，请刷新重试。',
    },
    action: {
      nodeAlreadyExists: '该{{type}}已存在于当前画布中',
      deleteSuccess: '工作流已删除',
      duplicateSuccess: '复制画布成功',
      nodeLimitReached: '画布已达到最大节点数限制 ({{max}})，请删除一些节点后再添加新节点。',
      approachingNodeLimit: '画布节点数量接近上限 ({{current}}/{{max}})，建议移除不必要的节点。',
      initializationFailed: '画布初始化失败，请稍后重试。',
    },
    skill: {
      askAI: 'AI 普通问答',
      askAIDescription: '向 AI 提问，获取写作、阅读理解或问题解答等帮助',
      switchSkillTooltip:
        '在输入框中使用 Ctrl + / 切换技能，默认提问技能为 AI 普通问答，可切换为其他技能，如网络搜索',
      switchSkillTooltipMac:
        '在输入框中使用 ⌘ + / 切换技能，默认提问技能为 AI 普通问答，可切换为其他技能，如网络搜索',
    },
    skillResponse: {
      executionFailed: '执行失败，点击重试',
      skillCompleted: '技能已完成',
      stepCompleted: '步骤已完成',
      rerunSingle: '仅运行此节点',
      runSingle: '仅运行此节点',
      stopSingle: '终止',
      promptRequired: '请先填写提示词',
      rerunFromHere: '从此节点开始运行',
      downstreamAgentsMissingPrompts: '后续节点中存在未填写提示词的 Agent',
      stopConfirmModal: {
        title: '停止 Agent 任务？',
        main: '确认停止此 Agent 任务吗？',
        note: '已完成的进度将被保存，已消耗的积分将不会返还。',
        cancel: '取消',
        confirm: '确定停止',
      },
      stopSuccess: 'Agent 已成功停止。',
      stepTitle: '步骤 {{index}}',
      aiThinking: 'AI 正在思考...',
      sourcesCnt: '共找到 {{count}} 个来源',
      executing: '技能正在执行，请稍候...',
      startRunning: '技能正在运行...',
      startRerun: '技能正在重新运行...',
      startPilotRecovery: '正在启动pilot恢复...',
      pilotRecoveryStarted: 'Pilot恢复已成功启动',
      pilotRecoveryFailed: 'Pilot恢复失败',
      resultNotFound: '抱歉，执行结果似乎已丢失。',
      reasoningContent: 'AIMfly 思考过程',
      shareLoading: '正在加载共享技能响应...',
      notFound: '技能响应未找到',
      notFoundDesc: '您查找的技能响应不存在或已被删除。',
      generating: '正在生成内容...',
      shareSuccess: '技能响应已成功分享！链接已复制到剪贴板。',
      shareError: '技能响应分享失败',
      error: {
        defaultTitle: '技能执行失败',
        description: '[{{errCode}}] {{errMsg}} 原始错误: {{rawError}}',
        networkError: '如果问题持续存在，请检查您的网络连接或 VPN',
      },
      creditInsufficient: {
        title: '积分不足',
        scheduleTitle: '升级以创建更多定时任务',
        description:
          '您当前订阅方案为 {{membershipLevel}}，积分已不足。升级套餐即可继续使用 AIMfly 的完整功能。',
        upgradeButton: '立即升级',
      },
      modelCallFailure: {
        title: '执行失败',
        description: '模型调用失败，请稍后重试或更换模型。',
        retryButton: '重试',
      },
      toolCallFailure: {
        title: '执行失败',
        description: '工具调用异常，请稍后重试或更换工具。',
        retryButton: '重试',
      },
      multimodalFailure: {
        title: '执行失败',
        description: '生成失败，请稍后重试或更换模型。',
        retryButton: '重试',
      },
      contentFiltering: {
        title: '内容被过滤',
        description: '您输入的内容包含敏感信息，请修改后重试',
        retryButton: '重试',
      },
      userAbort: {
        title: '任务已停止',
        description: '此任务已被手动终止。',
      },
      workflowFailure: {
        title: '执行失败',
        description: 'workflow 执行中断，请稍后重试或检查节点配置。',
        retryButton: '重试该节点',
        checkButton: '检查该节点',
      },
      config: {
        input: '输入项: ',
        model: '模型: ',
        tool: '工具: ',
        file: '文件: ',
        agent: ' 智能体: ',
      },
      status: {
        waiting: '等待中',
        executing: '运行中',
        finish: '成功',
        failed: '失败',
      },
    },
    chatHistory: {
      alreadyAdded: '已添加到对话历史',
      addSuccess: '成功添加到对话历史',
    },
    contextList: {
      placeholder: '搜索{{domain}}...',
    },
    newCanvas: {
      modalTitle: '新画布',
      titlePlaceholder: '请输入写作标题',
      descriptionPlaceholder: '请输入画布描述',
    },
    conflict: {
      title: '画布冲突',
      content: '画布似乎已被其他浏览器或设备修改。请选择保留本地版本或远程版本。',
      local: '保留本地版本 (最后修改时间: {{time}})',
      remote: '保留远程版本 (最后修改时间: {{time}})',
    },
    syncFailure: {
      title: '画布同步失败',
      content: '与服务器同步画布内容时似乎遇到了问题，请检查您的网络连接或稍后再试。',
      reload: '重新加载',
    },
    contextSelector: {
      placeholder: '搜索节点...',
    },
    contextManager: {
      nodeNotFound: '源节点未找到或已被删除，请先添加到画布',
    },
    nodeActions: {
      extractVariables: '提取变量',
      dragToConnect: '拖拽连线',
      clickToAdd: '点击添加',
      duplicateMemo: '复制备忘录',
      createMemo: '创建空备忘录',
      createMemoDescription: '创建一个空备忘录，用于快速记录想法，支持 Markdown 格式',
      copy: '复制节点内容',
      copyDescription: '将节点内容以 Markdown 格式复制到剪贴板',
      createDocumentDescription: '创建文档',
      askAI: '添加自定义Agent',
      askAIDescription:
        '向 AI 提问，选择上下文或切换技能后输入需求，获取写作、阅读理解或问题解答等帮助',
      cloneAskAI: '克隆 AI 提问',
      cloneAskAIDescription: '复制现有 AI 回答节点的所有参数创建新的技能节点，便于对比实验',
      batchRun: '批量运行',
      batchRunDescription: '同时运行多个选中的技能节点',
      addToContext: '添加到上下文',
      addToContextDescription: '为单次查询添加临时知识支持，提升 AI 回答准确度',
      processingVector: '处理向量',
      run: '运行',
      runDescription: '运行选中的技能节点',
      rerun: '重新运行',
      rerunDescription: '使用当前参数设置重新执行 AI 节点',
      preview: '打开预览',
      previewDescription: '在右侧预览面板中完整展示节点内容',
      fullScreen: '全屏预览',
      fullScreenDescription: '在全屏模式下预览节点内容',
      insertToDoc: '插入文档',
      insertToDocDescription: '将节点内容整合到文档中，支持迭代写作',
      askFollowUp: '继续提问',
      nextStepSuggestions: '下一步建议',
      title: '相关内容',
      nextStepSuggestionsDescription: '基于当前节点内容，AI 提供的下一步操作建议',
      followUpQuestion: '追问',
      moreOptions: '更多选项',
      delete: '删除节点',
      deleteDescription: '删除选中的节点',
      duplicate: '复制节点',
      duplicateDescription: '创建一个具有相同配置的节点副本',
      ungroup: '取消分组',
      ungroupDescription: '取消选中的节点分组',
      group: '创建分组',
      groupDescription: '基于选中的节点创建分组',
      deleteAll: '删除',
      deleteAllDescription: '删除画布中所有节点',
      compactMode: '紧凑模式',
      compactModeDescription: '紧凑模式，节点间距更小',
      adaptiveMode: '自适应模式',
      adaptiveModeDescription: '自适应模式，节点间距根据画布大小自动调整',
      selectCluster: '选中子节点',
      selectClusterDescription: '选中选中的节点下的所有子节点',
      groupCluster: '基于子节点建立组',
      groupClusterDescription: '基于选中的节点下的所有子节点创建分组',
      layoutCluster: '子节点自动布局',
      layoutClusterDescription: '自动布局选中的节点下的所有子节点',
      centerNode: '定位节点',
      centerNodeDescription: '将选中的节点定位到画布中心',
      createVariable: '转化为变量',
      alreadyCreated: '从变量中移除',
      editQuery: '编辑提问',
      editQueryDescription: '编辑选中的节点提问',
      duplicateDocument: '创建文档副本',
      duplicateDocumentDescription: '创建选中的节点文档副本',
      deleteResource: '删除资源',
      deleteResourceDescription: '从知识库以及所有画布中删除该资源',
      resourceDeleteConfirm: '确认要删除资源 [{{title}}] 吗？',
      deleteDocument: '删除文档',
      deleteDocumentDescription: '从知识库以及所有画布中删除该文档',
      documentDeleteConfirm: '确认要删除文档 [{{title}}] 吗？',
      downloadFile: '下载文件',
      editGroupNamePlaceholder: '请输入分组名称',
      addToSlideshow: '插入幻灯片',
      upgrade: '升级套餐',
      more: '更多选项',
      createAsDocument: '创建为文档',
      download: '下载',
      downloadSuccess: '下载成功',
      downloadError: '下载失败',
      downloadDescription: '下载节点内容到本地文件',
      runWorkflow: '从当前节点开始运行工作流',
      existWorkflowRunning: '工作流正在运行中',
      selectToEdit: '点击进入编辑器编辑',
    },
    download: {
      error: {
        noImageUrl: '未找到图片链接',
        noVideoUrl: '未找到视频链接',
        noAudioUrl: '未找到音频链接',
        noDocumentContent: '未找到文档内容',
        noCodeContent: '未找到代码内容',
        noSkillContent: '未找到技能响应内容',
        noMemoContent: '未找到备忘录内容',
        noResourceContent: '未找到资源内容',
        noWebsiteUrl: '未找到网站链接',
        unsupportedType: '不支持的节点类型: {{nodeType}}',
        general: '下载失败，请重试',
      },
      success: {
        image: '图片下载成功: {{fileName}}',
        video: '视频下载成功: {{fileName}}',
        audio: '音频下载成功: {{fileName}}',
        document: '文档下载成功: {{fileName}}',
        code: '代码下载成功: {{fileName}}',
        skillResponse: '技能响应下载成功: {{fileName}}',
        memo: '备忘录下载成功: {{fileName}}',
        resource: '资源下载成功: {{fileName}}',
        website: '网站链接下载成功: {{fileName}}',
      },
    },
    copy: {
      error: {
        noImageUrl: '未找到图片链接',
        noVideoUrl: '未找到视频链接',
        noAudioUrl: '未找到音频链接',
        noDocumentContent: '未找到文档内容',
        noCodeContent: '未找到代码内容',
        noSkillContent: '未找到技能响应内容',
        noMemoContent: '未找到备忘录内容',
        noResourceContent: '未找到资源内容',
        noWebsiteUrl: '未找到网站链接',
        unsupportedType: '不支持的节点类型: {{nodeType}}',
        general: '复制失败，请重试',
      },
      success: {
        image: '图片链接已复制到剪贴板',
        video: '视频链接已复制到剪贴板',
        audio: '音频链接已复制到剪贴板',
        document: '文档内容已复制到剪贴板',
        code: '代码内容已复制到剪贴板',
        skillResponse: '技能响应已复制到剪贴板',
        memo: '备忘录内容已复制到剪贴板',
        resource: '资源内容已复制到剪贴板',
        website: '网站链接已复制到剪贴板',
      },
    },
    share: {
      error: {
        noImageUrl: '未找到图片链接',
        noVideoUrl: '未找到视频链接',
        noAudioUrl: '未找到音频链接',
        noEntityId: '未找到实体ID',
        noMemoContent: '未找到备忘录内容',
        noWebsiteUrl: '未找到网站链接',
        unsupportedType: '不支持的节点类型: {{nodeType}}',
        general: '分享失败，请重试',
        document: '分享文档失败',
        code: '分享代码组件失败',
        skillResponse: '分享技能响应失败',
        resource: '分享资源失败',
      },
      success: {
        image: '图片链接已复制到剪贴板',
        video: '视频链接已复制到剪贴板',
        audio: '音频链接已复制到剪贴板',
        document: '文档分享成功！链接已复制到剪贴板',
        code: '代码组件分享成功！链接已复制到剪贴板',
        skillResponse: '技能响应分享成功！链接已复制到剪贴板',
        memo: '备忘录内容已复制到剪贴板',
        resource: '资源分享成功！链接已复制到剪贴板',
        website: '网站链接已复制到剪贴板',
      },
      loading: '正在创建分享...',
    },
    nodeStatus: {
      isCreatingDocument: '创建中...',
      createDocument: '创建文档',
    },
    nodePreview: {
      pin: '固定',
      unpin: '取消固定',
      document: {
        contentPreview: '加载文档内容中...',
        noContentPreview: '暂无内容预览',
      },
      resource: {
        contentPreview: '加载资源内容中...',
        noContentPreview: '暂无内容预览',
      },
      skillResponse: {
        contentPreview: '技能响应内容加载中...',
        noContentPreview: '暂无内容预览',
      },
    },
    operationMode: {
      title: '画布操作模式',
      mouse: '鼠标友好模式',
      mouseDesc: '鼠标左键拖动画布，滚轮缩放',
      touchpad: '触控板友好模式',
      touchpadDesc: '双指同向移动拖动，双指张开捏合缩放',
    },
    nodes: {
      socialPublish: {
        nodeTitle: '社媒发布',
        platform: '发布平台',
        accounts: '发布账号',
        contentTitle: '内容标题',
        description: '内容描述',
        tags: '标签',
      },
      website: {
        defaultTitle: '网站',
        addWebsite: '添加网站',
        websiteUrl: '网站 URL',
        urlRequired: '请输入网站 URL',
        preview: '预览',
        save: '保存并查看网站',
        copyUrl: '复制 URL',
        urlCopied: 'URL 已复制到剪贴板',
        copyFailed: '复制失败',
        openInNewTab: '在新标签页打开',
        edit: '编辑',
        noUrlProvided: '未提供网站 URL',
      },
      mindMap: {
        defaultTitle: '思维导图',
        edit: '编辑思维导图',
        preview: '预览',
        jsonData: '思维导图 JSON 数据',
        jsonRequired: '请输入有效的 JSON 数据',
        save: '保存并查看思维导图',
        export: '导出思维导图',
        clickToView: '点击查看思维导图',
        compactMode: '思维导图紧凑模式',
        nodesCount: '{{count}} 个节点',
        invalidJson: 'JSON 结构无效',
        exportFailed: '导出思维导图失败',
        addChild: '添加子卡片',
        addSibling: '添加同级卡片',
        delete: '删除卡片',
        invalidMindMapData: '思维导图数据格式无效，请检查您的 JSON 结构',
      },
      mediaSkill: {
        prompt: '请输入生成内容',
        mediaType: '媒体类型',
        image: '图片',
        video: '视频',
        audio: '音频',
        media: '媒体',
        mediaGenerate: '媒体生成',
        imageGenerate: '生成图片',
        videoGenerate: '生成视频',
        audioGenerate: '生成音频',
        imagePlaceholder: '描述你想要生成的图片...',
        videoPlaceholder: '描述你想要生成的视频...',
        audioPlaceholder: '描述你想要生成的音频...',
        defaultPlaceholder: '描述你想要生成的内容...',
        generating: '生成{{type}}...',
        failed: '生成失败',
      },
    },
    AIMflyPilot: {
      title: '问问 AI',
      newConversation: '新会话',
      clearConversation: '清空会话',
      welcome: {
        title: '你好，{{name}}!',
        subtitle: '今天我能帮您做什么？',
        suggestions: [
          '总结这篇文章',
          '为我的项目生成创意',
          '帮我写一篇博客',
          '解释这个概念',
          '为我起草一封电子邮件',
        ],
      },
    },
    resourceLibrary: {
      title: '文件',
      empty: '暂无文件',
      wideScreen: '宽屏',
      exitWideScreen: '退出宽屏',
      searchPlaceholder: '搜索项目资源',
      noSearchResults: '未搜索到任何结果',
      myUploadsDescription: '上传的资源将显示在此处',
      resultRecordDescription: '结果记录将显示在此处',
      stepsRecordDescription: '步骤记录将显示在此处',
      new: {
        document: '新建文档',
        resource: '导入文件',
        folder: '新建文件夹',
      },
      root: '根目录',
      folder: '文件夹',
      newFolderName: '请输入文件夹名称',
      importResource: '导入资源',
      createDocument: '新建文档',
      importFromKnowledgeBase: '从知识库导入',
      importFromExtension: '插件剪存',
      download: {
        success: '已下载，请去本地查看文件～',
        error: '下载失败，请重试',
        invalidUrl: '下载链接无效',
      },
    },
    richChatInput: {
      actions: '操作',
      userInput: '输入项',
      noUserInput: '暂无输入项',
      tools: '工具',
      noTools: '暂无工具',
      untitledTool: '未命名工具',
      files: '文件',
      noFiles: '暂无文件',
      untitledFile: '未命名文件',
      agents: '智能体',
      noAgents: '暂无智能体',
      untitledAgent: '智能体',
      hoverToViewVariables: '悬停左侧分类查看变量',
      loadingEditor: '加载编辑器中...',
      loadingUserInput: '加载用户输入中...',
      defaultPlaceholder: '描述你想要生成的内容...',
      createUserInput: '创建输入项 "{{userInputName}}"',
      unauthorized: '授权',
      oauthSuccess: '工具授权成功',
      oauthFailed: '工具授权失败',
      oauthTimeout: '授权超时，请重试',
      authorizing: '授权中...',
    },
    workflowDependency: {
      title: '工作流就绪检查',
      subtitle: '运行前请先解决以下问题',
      description: '工具依赖将显示在此处',
      uninstalledToolsCount: '{{count}}个工作流问题',
      searchPlaceholder: '搜索工具',
      uninstalled: '未安装',
      installed: '已安装',
      all: '全部',
      noSearchResults: '未找到匹配的工具',
      noToolsDependency: '暂无工作流依赖',
      descriptionPlaceholder: '工具介绍,最多二十个中文字',
      referencedNodes: '被引用节点',
      more: '更多',
      goToInstall: '安装',
      notAuthorized: '工具未授权',
      mcpUnavailable: '工具当前不可用',
      notEnoughCredits: '积分不足，无法运行',
      requiredInputNotFilled: '必填输入项未填写',
      inputName: '{{input_name}}',
      configure: '配置',
      upgrade: '升级',
      youAreAwesome: '已就绪',
      everythingIsSet: '工作流可正常运行',
    },
    multiModelSelector: {
      singleModel: '单一模型',
      multiModel: '多个模型',
      selectedCount: '已选择 {{count}} 个模型',
      clearAll: '清除全部',
    },
  },
  resource: {
    multilingualSearch: {
      title: '用您的语言搜索世界',
      placeholder: '搜索任何内容',
      searchLabel: '搜索语言：',
      displayLabel: '显示语言：',
      selectSearchLanguages: '选择搜索语言',
      selectDisplayLanguage: '选择显示语言',
      enableRerank: '启用重排序',
      searchLocales: '搜索语言',
      displayLocale: '显示语言',
      searchResults: '搜索结果',
      search: '搜索',
      noResults: '未找到结果',
      progress: {
        title: '搜索进度',
        summary: '{{count}} 个结果 ({{duration}}毫秒)',
        duration: '{{duration}}毫秒',
      },
      steps: {
        processing: '处理中...',
        rewriteQuery: {
          title: '重写查询',
          rewrittenQueries: '重写后的查询',
          outputLocale: '输出语言',
          searchLocales: '搜索语言',
        },
        translateQuery: {
          title: '翻译查询',
        },
        webSearch: {
          title: '网页搜索',
          results: '结果数',
          searchLocales: '搜索语言',
        },
        translateResults: {
          title: '翻译结果',
          results: '结果数',
          searchLocales: '搜索语言',
        },
        rerank: {
          title: '重新排序',
          finalResults: '最终结果数',
        },
        finish: {
          title: '完成',
        },
      },
    },
    import: {
      title: '导入文件',
      fromWebSearch: '全网搜索',
      fromFile: '导入本地文件',
      fromImage: '上传图片',
      dragOrClick: '点击或拖拽文件到此区域上传',
      unsupportedFileType: '请上传指定类型的文件',
      supportedFiles: '支持文件: {{formats}}',
      fileUploadLimit: '每个文件最大 {{size}}',
      unlockUploadLimit: '解锁上传限制',
      fileTooLarge: '文件大小不能超过 {{size}}',
      fileParsingUsage: '高级文件解析（包括 PDF）：今日已使用 {{used}}/{{limit}} 页',
      fileSizeLimit: '最大上传大小：{{size}}',
      fromWeblink: '导入网页链接',
      selectAll: '全选',
      webLinkPlaceholer: '输入或粘贴有效的网页链接，每行一个....',
      fromText: '复制文本',
      linkFormatError: '请输入有效的网页链接，以 http 或 https 开头',
      emptyLink: '你还未添加任何链接！',
      waitingList: '待处理文件',
      linkCount: '共 {{count}} 个',
      fileCount: '共 {{count}} 个',
      addToWaiting: '添加到待处理',
      addedToWaitingList: '已添加 {{count}} 个搜索结果到待处理列表',
      selectedCount: '已选择 {{count}} 个搜索结果',
      noPendingFiles: '暂未上传文件',
      uploading: '上传中',
      saveTo: '保存至',
      scrapeError: '抓取失败',
      integration: '集成',
      emptyText: '标题和文本内容不能为空！',
      textTitlePlaceholder: '输入标题',
      textUrlPlaceholder: '输入或粘贴网页链接',
      textContentPlaceholder: '输入或粘贴文本',
      saveResourceSuccess: {
        prefix: '保存成功，点击',
        link: '链接',
        suffix: '查看',
      },
      saveResourceFailed: '保存失败，请尝试重新保存',
      isSaving: '保存中...',
      storageLimited: '存储空间已满',
      storagePartialLimited: '存储空间不足，仅能保存 {{count}} 个资源',
      upgrade: '升级订阅',
      fromExtension: '浏览器插件剪存',
      extensionTitle: '一键保存网页内容',
      extensionDescription:
        '基于自由画布的创作平台，通过多线程对话、知识库整合、上下文记忆、智能搜索和 AI 文档编辑器，轻松将想法转化为优质内容。',
      downloadExtension: '下载插件',
      viewDocs: '查看文档',
      recommendedPlatforms: '推荐在以下平台使用',
      selectProject: '选择项目',
      emptyImage: '请至少选择一张图片',
      imageCount: '图片数量：{{count}}',
      supportedImages: '支持的图片格式：{{formats}}',
    },
    init: '待解析',
    wait_parse: '内容解析中',
    wait_parse_tip: '文件未被解析，暂时无法查看',
    parse_failed: '解析失败',
    wait_index: '模型记忆中',
    wait_index_tip: '该资源暂时不支持 AI 搜索，需等待模型记忆完成',
    index_failed: '模型记忆失败',
    index_failed_tip: '点击重试',
    finish: '已索引',
    clickToPreview: '点击查看详情',
    pageLimitExceeded:
      '此文件有 {{numPages}} 页，超出高级文件解析的每日页数限制（今日已使用 {{used}}/{{limit}} 页）。',
    unknownError: '未知错误，请稍后再试',
  },
  resourceDetail: {
    back: '所有资源',
    directory: {
      baseInfo: '基础信息',
      techInfo: '技术信息',
      addTime: '添加时间',
      updateTime: '更新时间',
      source: '来源',
      storageSize: '文件存储',
      vectorSize: '向量存储',
      indexStatus: '索引状态',
      referenced: '{{count}} 被引用',
      weblink: '网页链接',
      text: '文本',
    },
  },
  codeArtifact: {
    fix: {
      title: '修复代码错误',
      query: '帮我优化这段代码。我遇到了以下错误：\n\n{{errorMessage}}',
      tryToFix: '尝试修复',
      error: '错误',
      errorConfig: '代码错误配置',
      requestingFix: '正在请求 AI 修复错误...',
      closeErrorMessage: '关闭错误信息',
      copyErrorMessage: '复制错误信息',
      errorDismissed: '已关闭错误信息',
    },
    editor: {
      fontFamily: '字体',
      fontSize: '字号',
      fontLigatures: '连字',
      theme: '主题',
      loading: '编辑器加载中...',
      useFallback: '使用文本编辑器',
      loadError: '编辑器加载失败',
      generatingContent: 'AI 正在生成内容',
      generatingPlaceholder: '内容生成中...',
      fallbackMode: '简易编辑器模式',
      contentTruncated:
        '内容较长，仅显示最后 {{chars}} 个字符（共 {{total}} 个字符）。生成完成后将显示完整内容。',
    },
    copySuccess: '代码已复制到剪贴板',
    copyError: '复制代码失败',
    downloadSuccess: '已下载 {{fileName}}',
    downloadError: '下载文件失败',
    refreshing: '预览刷新中...',
    creating: '创建代码组件中...',
    loading: '加载代码组件中...',
    sharing: '分享代码中...',
    shareLoading: '加载分享代码中...',
    noCodeFound: '暂无代码内容',
    noSelection: '未选择代码组件',
    shareSuccess: '分享链接已复制到剪贴板! ',
    shareError: '分享代码失败',
    errorCopySuccess: '错误信息已复制到剪贴板',
    errorCopyFailed: '复制错误信息失败',
    layout: {
      split: '分栏视图',
      tabs: '标签视图',
    },
    layoutChanged: {
      split: '已切换到分栏视图模式',
      tabs: '已切换到标签视图模式',
    },
    tabs: {
      preview: '预览',
      code: '代码',
    },
    buttons: {
      refresh: '刷新',
      copy: '复制代码',
      download: '下载 {{fileName}}',
      share: '分享小组件',
    },
    defaultTitle: '代码组件',
  },
  agent: {
    configure: '输入',
    lastRun: '输出',
    runlog: '运行日志',
    noResult: '运行后才有记录哦',
    editTitlePlaceholder: '输入智能体的标题',
    config: {
      model: '模型',
      modelDescription:
        '选择智能体运行时使用的 AI 模型。不同模型在理解、生成和工具调用上能力不同。',
      prompt: '提示词',
      promptDescription:
        '告诉智能体要执行什么任务。您可以在提示词中引用输入项和其他内容，使用 @ 符号。',
      inputs: '输入项',
      inputsDescription: '智能体可用的用户提供的信息。这些通常来自运行工作流时填写的表单字段。',
      tools: '工具',
      toolsDescription: '智能体可调用的外部服务，如 Gmail 等。',
      files: '文件',
      filesDescription: '智能体可读取的文件，如图片、文档或其他上传的资源。',
      agents: '智能体',
      agentsDescription: '使用其他智能体产出的结果，完成当前节点的任务。',
      addToolsAndContext: '添加工具和上下文',
    },
  },
  loggedHomePage: {
    searchEverything: '搜索任何内容',
    quickSearch: {
      skills: '技能',
      canvas: '画布',
      newCanvas: '创建新画布',
      resource: '资源',
      newResource: '添加资源',
      document: '文档',
      newDocument: '创建新文档',
      placeholderForHome: '搜索画布、文档或资源...',
      placeholderForSkillExecute: '输入你想要提问的问题，并基于此问题执行技能',
      placeholderForWeblink: '搜索 {{domain}}...',
      home: {
        heading: '建议',
        showAll: '查看所有{{heading}}',
      },
      skill: '技能',
    },
    homePage: {
      searchPlaceholder: '输入搜索内容...',
      selectedWeblink: {
        title: '基于选中网页提问：',
      },
      recommendQuickAction: {
        title: '推荐快捷操作：',
        summary: {
          title: '总结',
          tip: {
            title: '总结',
            current: '对当前网页进行快速{{action}}',
            selectedWeblink: '对选中的网页进行{{action}}',
            currentSelectedContent: '基于实时选择内容{{action}}',
          },
          status: {
            contentHandling: '处理内容中...',
            createFailed: '创建新会话失败！',
            contentHandleSuccessNotify: '处理成功，正在跳转到会话页面...',
            contentHandleFailedNotify: '处理失败！',
          },
        },
        save: {
          title: '保存',
          tip: '保存此网页以供后续阅读',
          status: {
            contentHandling: '内容保存中...',
            createFailed: '创建新会话失败！',
            contentHandleSuccessNotify: '保存成功！',
            contentHandleFailedNotify: '处理失败！',
          },
        },
      },
      seeKnowledgeLibrary: '查看知识库',
      status: {
        createFailed: '创建新会话失败！',
      },
    },
    siderMenu: {
      home: '工作台',
      canvas: '工作流',
      runHistory: '运行历史',
      appManager: '我的模版',
      marketplace: '模板市场',
      templateMarket: '模板市场',
      userGuide: 'AIMfly使用教程',
      contactUs: '联系我们',
      addToChrome: '安装浏览器插件',
      canvasTitle: '画布',
      canvasDescription:
        '创建、编辑和查看画布, 不同于传统的 Chatbot 应用，AIMfly 通过无限延伸的二维画布来完成对话思考、内容消费和创作的全流程。',
      libraryTitle: '知识库',
      libraryDescription:
        '创建、编辑和查看知识库，包含所有导入的资源以及创建的文档，支持 AI 语义搜索和回答。',
      subscription: '订阅管理',
      newCanvas: '新建画布',
      importCanvas: '导入画布',
      news: '新特性',
      explore: '探索',
      threadLibrary: '会话',
      getHelp: '获得帮助',
      download: '下载',
      downloadExtension: '下载插件',
      newResource: '导入资源',
      settings: '设置',
      skill: '技能',
      collapse: '折叠',
      expand: '展开',
      logout: '登出',
      library: '知识库',
      newDocument: '新建文档',
      recentProjects: '最近项目',
      recentChats: '最近会话',
      viewMore: '查看更多',
      viewTutorial: '查看文档',
      tour: '查看教程',
      template: '模板',
      systemTheme: '外观',
    },
  },
  knowledgeLibrary: {
    header: {
      archive: '归档',
      timeline: '时间线',
      seeAll: '查看全部',
      trendingTopic: '趋势主题：',
    },
    archive: {
      title: '浏览内容归档',
      item: {
        askFollow: '追问阅读',
        share: '分享',
        copy: '复制链接',
        copyNotify: '链接已复制到剪贴板',
        noMoreText: '已经到底啦~',
        linkMore: '{{count}} 条更多',
      },
    },
    timeline: {
      title: '{{year}} 年 {{month}} 月 {{day}} 日浏览内容',
    },
    empty: {
      timelineTitle:
        '{{year}} 年 {{month}} 月 {{day}} 日还未阅读新内容，赶快下载插件去阅读新内容吧',
      archiveTitle: '还未阅读任何内容，赶快下载插件去阅读新内容吧~',
      download: '下载插件',
      seeOther: '查看其他日期内容',
    },
  },
  threadLibrary: {
    breadcrumb: {
      homePage: '主页',
      allTopics: '所有主题',
    },
    title: '会话库',
    newThread: '新会话',
    footer: {
      noMoreText: '已经到底啦~',
    },
    item: {
      askFollow: '继续提问',
      messageCount: '{{count}} 条消息',
    },
    empty: {
      title: '暂无无会话，赶紧下载插件或访问首页提问吧~',
      download: '下载插件',
      goHome: '去首页搜索或提问',
    },
  },
  skill: {
    tab: {
      skillInstances: '已添加技能',
      skillTemplate: '技能市场',
    },
    runtimeConfig: {
      parseLinks: '解析链接',
      parseLinksHint: '此技能会自动从提问中读取 {{count}} 个链接，并将其添加到上下文中',
    },
    skillManagement: {
      searchPlaceholder: '搜索技能',
      removedFromTop: '已从置顶列表中移除',
      toppedSuccessfully: '已置顶',
      toppedLimit: '置顶技能已达上限，请先取消置顶再重新置顶',
      alreadyTopped: '已置顶',
      addToTop: '置顶',
      removeFromTop: '取消置顶',
    },
    createFromTemplate: '从模板创建',
    newSkillModal: {
      newTitle: '创建技能',
      updateTitle: '更新技能',
      name: '名称',
      namePlaceholder: '请输入技能名称',
      description: '描述',
      descriptionPlaceholder: '请输入技能描述',
      cancel: '取消',
      confirm: '确定',
      putErr: '操作失败，请尝试重试！',
      putSuccess: '操作成功',
      basicInfo: '基础信息',
    },
    newTriggerModal: {
      newTitle: '创建触发器',
      updateTitle: '更新触发器',
      triggerConfig: '触发器配置',
      name: '名称',
      namePlaceholder: '请输入触发器名称',
      triggerType: '类型',
      triggerTypePlaceholder: '请选择触发器类型',
      timer: '定时触发',
      simpleEvent: '事件触发',
      onResourceReady: '资源准备就绪',
      timerConfig: '时间',
      timerConfigPlaceholder: '请选择运行时间',
      repeatInterval: '重复',
      repeatIntervalPlaceholder: '请选择重复间隔',
      resource: '资源',
      resourcePlaceholder: '请选择资源',
      event: '事件',
      eventPlaceholder: '请选择事件',
      hour: '每小时',
      day: '每天',
      week: '每周',
      month: '每月',
      year: '每年',
    },
    instanceInvokeModal: {
      title: '运行技能',
      formLabel: {
        query: '问题',
        resources: '资源',
        notes: '画布',
        collections: '知识库',
        contentList: '内容',
        urls: '链接列表',
      },
      placeholder: {
        query: '请输入问题',
        resources: '请选择资源',
        notes: '请选择画布',
        collections: '请选择知识库',
        contentList: {
          select: '请选择内容',
          textarea: '请输入或粘贴内容',
        },
        urls: '请输入链接，每行一个...',
      },
      context: {
        contentList: {
          resourceSelection: '资源选中',
          documentSelection: '文档选中',
          extensionWeblinkSelection: '网页选中',
          documentCursorSelection: '文档光标选中内容',
          documentBeforeCursorSelection: '文档光标前内容',
          documentAfterCursorSelection: '文档光标后内容',
        },
      },
      invokeConfig: '运行配置',
      templateConfig: '模板配置',
    },
    skillDetail: {
      run: '运行',
      delete: '删除',
      jobs: '运行记录',
      triggers: '触发器',
      addTrigger: '添加触发器',
      back: '返回技能管理',
      emptyJobs: '暂无运行记录',
      emptyTriggers: '请先配置触发器',
      emptyInstances: '您未安装任何技能',
      emptyTemplates: '技能市场空空如也',
      enable: '启用',
      disable: '禁用',
    },
    skillRunStatus: {
      error: '发生错误，错误信息：{{error}}',
    },
  },
  settings: {
    title: '设置',
    tabs: {
      providers: '供应商配置',
      modelConfig: '模型配置',
      parserConfig: '解析配置',
      resourceParser: '资源解析',
      defaultModel: '默认模型',
      account: '账号',
      language: '语言',
      appearance: '外观',
      subscription: '订阅',
      mcpServer: 'MCP 服务器',
      tools: '工具',
      modelSetting: '模型',
    },
    modelSetting: {
      sourceBuiltin: '内置模型',
      sourceCustom: '自定义模型',
      typePlaceholder: '选择模型类型',
      typeAll: '全部',
      typeLlm: '语言模型',
      typeImage: '图片生成模型',
      typeVideo: '视频生成模型',
      typeMultimodal: '多模态模型',
      typeVision: '视觉理解模型',
      searchPlaceholder: '搜索模型或供应商',
      addModel: '添加模型',
      edit: '编辑',
      delete: '删除',
      deleteConfirmTitle: '提示',
      deleteConfirmContent: '确定删除模型{{name}}吗?',
      deleteConfirmOk: '确定',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      statusEnabledSuccess: '启用成功',
      statusDisabledSuccess: '关闭成功',
      statusFailed: '更新启用状态失败',
      createSuccess: '已成功添加模型',
      createFailed: '添加模型失败',
      updateSuccess: '已保存模型',
      updateFailed: '保存模型失败',
      loadFailed: '模型列表加载失败',
      modal: {
        addTitle: '添加模型',
        editTitle: '编辑模型',
        tabProvider: '模型服务商',
        tabCustom: '自定义配置',
        provider: '服务商',
        providerPlaceholder: '选择模型服务商',
        providerRequired: '服务商为必填项',
        billingMode: '配置方式',
        billingModeRequired: '配置方式为必填项',
        billingPayAsYouGo: '按量计费',
        billingCodingPlan: 'Coding Plan',
        billingAgentpPlan: 'Agent Plan',
        model: '模型',
        modelPlaceholder: '选择模型',
        modelRequired: '模型为必填项',
        modelId: '模型 ID',
        modelIdPlaceholder: '请输入模型 ID',
        modelIdRequired: '模型 ID 为必填项',
        awsModelId: '模型ID',
        awsModelIdPlaceholder: '输入模型ID',
        otherModel: '使用其他模型',
        otherModelTip: '配置自定义模型ID使用非列表内模型',
        lookupModelId: '前往服务商平台查询',
        accessKey: '访问密钥',
        accessKeyPlaceholder: '请输入Access Key',
        accessKeyRequired: '访问密钥为必填项',
        secretKey: '私钥',
        secretKeyPlaceholder: '请输入Secret Key',
        secretKeyRequired: '私钥为必填项',
        region: '区域',
        regionPlaceholder: '输入区域',
        regionRequired: '区域为必填项',
        modelType: '模型类型',
        modelTypePlaceholder: '选择类型',
        modelTypeRequired: '模型类型为必填项',
        apiFormat: 'API 格式',
        apiFormatRequired: 'API 格式为必填项',
        apiFormatOpenAI: 'OpenAI Chat Completions 格式',
        apiFormatAnthropic: 'Anthropic Messages 格式',
        baseUrl: '自定义请求地址',
        baseUrlPlaceholder: '例如 https://api.openai.com/v1',
        baseUrlPlaceholderAnthropic: '例如 https://api.anthropic.com/v1',
        baseUrlRequired: '自定义请求地址为必填项',
        baseUrlHelpOpenAI:
          '请填写兼容 OpenAI API 的服务端点地址，不要以斜杠结尾，/chat/completions 将会被补充到你填写的地址末尾。',
        baseUrlHelpAnthropic:
          '请填写兼容 Claude API 的服务端点地址，不要以斜杠结尾，/chat/completions 将会被补充到你填写的地址末尾。',
        apiKey: 'API 密钥',
        apiKeyPlaceholder: '请输入 API 密钥',
        apiKeyRequired: 'API 密钥为必填项',
        contextLimit: '上下文数量限制',
        maxOutputToken: '最大输出 token',
        limitPlaceholder: '留空则按最佳默认值',
        enabled: '是否启用',
        enable: '启用',
        disable: '关闭',
        reset: '重置',
        save: '保存模型',
        testing: '连通性测试中',
        testFailed: '请求模型供应商失败，请根据返回的原始错误信息排查问题',
        submitFailed: '保存失败，请稍后重试',
      },
    },
    mcpServer: {
      tools: '工具',
      mcp: 'MCP',
      myServers: '我的服务器',
      mcpStore: 'MCP 市场',
      toolStore: '工具市场',
      title: 'MCP 服务器管理',
      name: '名称',
      type: '类型',
      url: '地址 / 命令',
      command: '命令',
      args: '参数',
      headers: '请求头',
      env: '环境变量',
      reconnect: '重连设置',
      enabled: '启用状态',
      status: '状态',
      noServers: '暂无 MCP 服务器',
      addServer: '添加 MCP',
      editServer: '编辑 MCP',
      deleteServer: '删除 MCP',
      deleteConfirmTitle: '删除 MCP 服务器',
      deleteConfirmMessage: '确定要删除 MCP 服务器 "{{name}}" 吗？',
      deleteSuccess: 'MCP 服务器删除成功',
      deleteError: 'MCP 服务器删除失败',
      createSuccess: 'MCP 服务器创建成功',
      createError: 'MCP 服务器创建失败',
      updateSuccess: 'MCP 服务器更新成功',
      updateError: 'MCP 服务器更新失败',
      validateSuccess: 'MCP 服务器验证成功',
      validateError: 'MCP 服务器验证失败',
      nameRequired: '请输入服务器名称',
      typeRequired: '请选择服务器类型',
      urlRequired: '请输入服务器地址',
      commandRequired: '请输入命令',
      namePlaceholder: '输入服务器名称',
      urlPlaceholder: '输入服务器地址（例如：http://localhost:5173）',
      commandPlaceholder: '输入命令（例如：node server.js）',
      argPlaceholder: '输入参数',
      addArg: '添加参数',
      headerKey: '请求头名称',
      headerValue: '请求头值',
      addHeader: '添加请求头',
      envKey: '环境变量名',
      envValue: '环境变量值',
      addEnv: '添加环境变量',
      maxAttempts: '最大重连次数',
      delayMs: '重连延迟（毫秒）',
      validate: '验证',
      formMode: '表单模式',
      jsonMode: 'JSON 模式',
      jsonModeStdioWarning:
        "通过 JSON 配置时请注意：Web 版本不支持 'stdio' 类型，这可能会导致意外行为。",
      jsonParseError: 'JSON 格式无效',
      typeSSE: '服务器发送事件',
      typeStreamable: '流式 API',
      typeStdio: '标准输入输出',
      stdioWebDisabledTooltip: 'Web 版本不支持 Stdio 协议。',
      batchImport: '批量导入',
      batchImportTitle: '批量导入 MCP 服务器',
      batchImportDescription:
        '通过提供 JSON 数组一次性导入多个 MCP 服务器。数组中的每个对象应代表一个服务器配置。',
      importServers: '导入服务器',
      batchImportSuccess: '成功导入 {{total}} 个服务器中的 {{count}} 个',
      batchImportPartialError: '{{total}} 个服务器中的 {{count}} 个导入失败',
      batchImportEmptyError: '没有要导入的服务器。请提供有效的服务器配置 JSON 数组。',
      universalFormat: '通用格式',
      AIMflyFormat: 'AIMfly 格式',
      reconnectTooltip: '当服务器连接断开时的自动重连设置',
      enabledTooltip: '启用或禁用此 MCP 服务器',
      validatingBeforeEnable: '正在验证服务器连接，验证成功后将自动启用',
      autoValidateHint: '服务器将在保存前自动验证连接',
      envKeyRequired: '环境变量名称不能为空',
      envValueRequired: '环境变量值不能为空',
      headerKeyRequired: '请求头名称不能为空',
      headerValueRequired: '请求头值不能为空',
      noToolsAvailable: '暂无可用工具',
      availableToolsPrefix: '可用工具: ',
      collapse: '收起',
      viewMore: '查看更多',
      viewToolsWithCount: '查看工具 ({{count}})',
      // 社区 MCP
      community: {
        title: '社区 MCP 配置',
        description: '发现并安装社区 MCP 配置',
        searchPlaceholder: '搜索配置...',
        filterByType: '按类型过滤',
        allTypes: '全部类型',
        install: '安装',
        installing: '安装中...',
        installed: '已安装',
        installSuccess: '成功安装 {{name}}',
        installError: '安装 {{name}} 失败',
        requiresApiKeyWarning: '{{name}} 需要 API 密钥，请在详细视图中配置。',
        viewDocumentation: '查看文档',
        noDescription: '暂无描述',
        loadError: '加载社区配置失败',
        loadErrorDescription: '请检查网络连接并重试。',
        noConfigurations: '未找到社区配置',
        author: '作者：{{author}}',
        version: 'v{{version}}',
        types: {
          sse: '服务器发送事件 (SSE)',
          streamable: '流式 API',
          stdio: '标准输入输出 (Stdio)',
          websocket: 'WebSocket',
        },
        // API Key 配置相关翻译
        configureApiKey: '配置 API Key',
        apiKeyRequired: '需要 API Key',
        apiKeyDescription: '此 MCP 服务器需要 API Key 才能正常工作。',
        apiKeyLabel: 'API Key',
        apiKeyPlaceholder: '请输入您的 API Key...',
        authMethod: '认证方式',
        auth: {
          urlParam: 'URL 参数',
          bearerToken: 'Bearer 令牌',
          headerKey: '请求头 ({{header}})',
          apiKey: 'API Key',
        },
        validateAndInstall: '验证并安装',
        validating: '验证中...',
        validateSuccess: '验证成功',
        validateError: '验证失败',
      },
    },
    toolStore: {
      title: '工具市场',
      noSearchResults: '没有找到相关工具',
      noTools: '暂无工具',
      searchPlaceholder: '搜索工具...',
      installedTools: '已安装工具',
      availableTools: '可用工具',
      install: {
        installTitle: '安装工具',
        updateTitle: '更新工具',
        name: '名称',
        namePlaceholder: '请输入工具名称',
        authType: '认证类型',
        authTypePlaceholder: '请选择认证类型',
        nameDuplicate: '工具名称已存在',
        install: '安装',
        installed: '已安装',
        update: '更新',
        updateSuccess: '更新成功',
        updateError: '更新失败',
        installSuccess: '安装成功',
        installError: '安装失败',
        required: '{{name}} 必填',
        toolEnabled: '已启用{{name}}',
        toolDisabled: '已禁用{{name}}',
        oauthStatus: 'OAuth 状态',
      },
      oauth: {
        checking: '检查 OAuth 状态中...',
        authorized: 'OAuth 已授权',
        required: '需要 OAuth 授权',
        authorizeWith: '使用 {{provider}} 授权',
        checkFailed: '检查 OAuth 状态失败',
        revoke: '撤销授权',
        revokeWith: '撤销 {{provider}} 授权',
        revokeConfirm: '确定要撤销授权吗？',
        revokeSuccess: '成功撤销授权',
        revokeError: '撤销授权失败',
      },
    },
    appearance: {
      title: '外观',
      themeMode: '主题模式',
      lightMode: '浅色模式',
      darkMode: '深色模式',
      systemMode: '跟随系统',
    },
    guide: {
      title: '设置向导',
      description: '👋 欢迎使用 AIMfly！让我们开始进行一些必要的设置。',
    },
    account: {
      title: '我的账号',
      avatar: '头像',
      name: '用户名',
      namePlaceholder: '请输入用户名',
      nickname: '昵称',
      nameValidationError: '用户名只能包含字母、数字和下划线，且长度不能超过30个字符',
      nicknamePlaceholder: '请输入昵称',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱',
      update: '更新',
      updateError: '更新用户信息失败，请重试',
      updateSuccess: '更新用户信息成功',
      nameInvalid: '该用户名已被占用',
      editAccount: '编辑账号资料',

      logout: '退出登录',
      logoutConfirmation: {
        title: '退出登录',
        message: '确定退出登录吗？',
      },
      uploadAvatar: '上传头像',
      imageSizeLimited: '图片必须小于{{size}}MB',
      onlyImageAllowed: '只支持上传{{type}}格式的图片',
      cropAvatar: '裁剪头像',

      // 邀请码
      invitationCodes: '邀请码',
      noInvitationCodes: '暂无邀请码',
      expiresAt: '过期时间',
      copy: '复制',
      statusUsed: '已使用',
      enterInvitationCode: '请输入邀请码',
      activateInvitationCode: '激活邀请码',
      activateInvitationCodeSuccess: '欢迎使用 AIMfly 🎉 开始您的 vibe-workflow 之旅吧！',
      activateInvitationCodeFailed: '邀请码无效。',
      activateInvitationCodeInvalid: '邀请码无效。',
      activateInvitationCodeUsed: '邀请码已被使用。',
      activateInvitationCodeAlreadyInvited: '该用户已被邀请。',
      activateInvitationCodeOwnCode: '不能使用自己的邀请码。',
      activateInvitationCodeAlreadyActivated: '该邀请已激活。',
      invitationCodeCopied: '邀请码已复制！快去分享给你的朋友吧~',
      invitationCodeCopyFailed: '复制邀请码失败',
      invitationReward: '+{{amount}}积分',
      inviteFriendsTitle: '邀请好友，领取奖励',
      inviteFriendsSubtitle: '你们都可获得 500 积分',
      invitationLimitText: '每位用户可邀请 {{used}}/{{limit}} 次',
      copyInvitationCodeAction: '复制',
      resendInvitationCodeAction: '重邀',
      statusUnknown: '未知',
      tapCardToCopy: '点击复制邀请码',
    },
    language: {
      title: '语言设置',
      uiLocale: {
        title: '界面语言',
        description: '设置 AIMfly 产品中所有交互内容的语言。',
      },
      outputLocale: {
        title: '对话语言',
        description: 'AI 将按照此语言设置回答您的问题。',
        auto: '自动检测',
      },
    },
    subscription: {
      mostPopular: '最受欢迎',
      getStarted: '开始使用',
      subscribeNow: '立即订阅',
      manage: '管理订阅',
      currentPlan: '当前套餐',
      t1Requests: 'T1 模型请求',
      t1RequestsDescription:
        'T1 模型包括 Claude 3.7 Sonnet (Thinking), DeepSeek R1, o3 Mini, GPT-4o 等模型。每个成功的技能调用计为一次请求。',
      t2Requests: 'T2 模型请求',
      t2RequestsDescription:
        'T2 模型包括 Gemini Flash 2.0, DeepSeek V3, Claude 3.5 Haiku 等模型。每个成功的技能调用计为一次请求。',
      requestsRefresh: '免费用户每天会重置次数。',
      libraryStorage: '知识库文件数',
      libraryStorageDescription: '知识库中每个资源和文档计为一个文件。',
      advancedFileParsing: '高级文件解析',
      advancedFileParsingDescription: '支持表格、图片和公式提取的 PDF 解析，按解析页数计算用量。',
      fileSizeLimit: '文件上传限制',
      fileSizeLimitDescription: '每个文件大小不能超过 {{size}} MB。',
      subscriptionManagement: '管理账单及订阅',
      subscriptionStatus: {
        free: 'FREE',
        maker: 'MAKER',
        starter: 'STARTER',
        ultra: 'ULTRA',
        pro: 'PRO',
        max: 'MAX',
        plus: 'PLUS',
      },
      subscribe: {
        title: '选择适合您的套餐',
        subtitle: '订阅年度计划立省20%，立即订阅再享额外50%折扣！',
        monthly: '按月',
        yearly: '按年',
        monthlyPlan: '每月自动续费',
        yearlyPlan: '每年自动续费',
        cancelAt: '将于 {{date}} 取消',
        trialExpireAt: '试用将于 {{date}} 结束',
        tooltip: {
          modelToken: 'Token 同时包括模型输入和输出',
          vectorStorage: '用于存储资源和画布的语义化向量数据',
          fileStorage: '用于存储资源文本、画布文本和历史版本、以及上传的文件（图片）数据',
          mediaCredit: '用于生成一张图或一秒视频',
        },
        vectorStorage: '向量存储',
        fileStorage: '文件存储',
        t1Model: 'T1 模型',
        t2Model: 'T2 模型',
        freeModel: '免费模型',
        mediaCredit: '多媒体积分（即将推出）',
        upgrade: '立即升级',
        continueFree: '继续免费',
        oneTime: '一次性',
        unlimited: '无限量',
        libraryStorage: '知识库容量',
        fileCounts: '{{count}} 个文件',
        dailyCounts: '{{count}} 次/每天',
        monthlyCounts: '{{count}} 次/每月',
        dailyPagesCount: '{{count}} 页/每天',
        fileSizeLimit: '最大 {{count}} MB',
        free: {
          description: '创意之旅的起点',
          serviceSupport: {
            name: '服务支持',
            details: '社区支持（微信或飞书群）',
          },
        },
        ultra: {
          description: '尽情释放无限创意',
          serviceSupport: {
            name: '服务支持',
            details: '专属微信/ Discord 群聊',
          },
        },
        plus: {
          description: '释放创作潜能，体验进阶模型',
          serviceSupport: {
            name: '服务支持',
            details: '高优邮件支持',
          },
        },
        pro: {
          description: '专业创作者的理想之选',
          serviceSupport: {
            name: '服务支持',
            details: '高优邮件支持',
          },
        },
        max: {
          description: '自由创作的巅峰体验',
          serviceSupport: {
            name: '服务支持',
            details: '专属微信/ Discord 群聊',
          },
        },
        description: '可随时取消订阅。订阅即表示您同意AIMfly的',
        and: '和',
        privacy: '隐私',
        terms: '条款',
        planFeatures: '套餐包含',
        period: '永久',
        month: '月',
        year: '年',
        firstYear: '首年',
        firstYearOffCountDescription: '首年享受五折优惠，次年将恢复原价',
        forFree: '免费',
        resetAt: '将于 {{date}} 重置',
      },
    },
    action: {
      putErrorNotify: '修改用户配置失败，请尝试重试！',
      paySuccessNotify: '支付成功！',
      paySuccessDescription: '感谢您对 AIMfly 的大力支持，我们会持续迭代，让产品变得更好！',
      payCancelNotify: '支付取消！',
      payCancelDescription: '我们未能成功收到您的付款，如有任何问题，请重新尝试支付。',
    },
    modelProviders: {
      // Tabs
      myProviders: '我的供应商',
      providerStore: '供应商商店',

      addProvider: '添加供应商',
      editProvider: '编辑供应商',
      providerType: '类型',
      apiKey: 'API Key',
      baseUrl: 'Base URL',
      enable: '启用',
      enabled: '是否启用',
      disable: '禁用',
      name: '名称',
      namePlaceholder: '请输入供应商名称',
      apiKeyPlaceholder: '请输入供应商 API Key',
      baseUrlPlaceholder: '请输入供应商 Base URL',
      enabledPlaceholder: '请选择是否启用',
      searchPlaceholder: '搜索供应商',
      tryDifferentSearch: '尝试不同的搜索',
      noSearchResults: '没有找到任何供应商',
      noProviders: '暂无供应商',
      addFirstProvider: '添加第一个供应商',
      deleteConfirm: '确定删除供应商 {{name}} 吗？',
      selectProviderType: '请选择供应商类型',
      category: '类别',
      categoryPlaceholder: '请至少选择一个',
      categories: {
        llm: 'LLM',
        webSearch: '网页搜索',
        urlParsing: 'URL 解析',
        pdfParsing: 'PDF 解析',
        reranker: '重排器',
        embedding: '嵌入',
        mediaGeneration: '媒体生成',
      },
      testConnection: '测试连接',
      testing: '测试中...',
      connectionTestSuccess: '测试连接成功',
      connectionTestFailed: '测试连接失败',
      testConnectionFailed: '测试连接失败',
      createTempProviderFailed: '创建临时供应商失败',
      apiConnectionFailed: 'API连接失败',
      testTime: '测试时间',
      selectProviderFirst: '请先选择供应商类型',
      viewDetails: '查看详情',
      // Provider Store 相关翻译
      community: {
        title: '社区供应商配置',
        description: '发现并安装社区供应商配置',
        searchPlaceholder: '搜索配置...',
        filterByCategory: '按类别过滤',
        allCategories: '全部类别',
        install: '安装',
        installing: '安装中...',
        installed: '已安装',
        installSuccess: '成功安装 {{name}}',
        installError: '安装 {{name}} 失败',
        requiresApiKeyWarning: '{{name}} 需要 API 密钥，请在详细视图中配置。',
        viewDocumentation: '查看文档',
        documentation: '文档',
        noDescription: '暂无描述',
        loadError: '加载社区配置失败',
        loadErrorDescription: '请检查网络连接并重试。',
        noConfigurations: '未找到社区配置',
        author: '作者：{{author}}',
        version: 'v{{version}}',
        // API Key 配置弹框
        configureApiKey: '配置 API Key',
        apiKeyRequired: '需要 API Key',
        apiKeyRequiredDescription:
          '此提供商需要您提供 API Key 才能使用。请从提供商官网获取 API Key 并填写在下方。',
        apiKeyLabel: 'API Key',
        apiKeyPlaceholder: '请输入您的 API Key',
        baseUrlLabel: 'Base URL (可选)',
        baseUrlDescription: '如需使用自定义服务地址，请填写此项',
        baseUrlPlaceholder: '使用默认地址',
        validateAndInstall: '验证并安装',
        validating: '验证中...',
        validateSuccess: '验证成功',
        validateError: '验证失败',
        cancel: '取消',
      },
    },
    modelConfig: {
      title: '模型配置',
      chatModels: '对话模型',
      otherModels: '其他模型',
      conversationModels: '对话模型',
      mediaGeneration: '媒体生成',
      mediaGenerationDescription: '用于生成图片、视频等多媒体内容',
      vision: '视觉模型',
      visionDescription: '用于图像识别、视觉问答等多模态任务',
      addFirstMediaModel: '添加第一个媒体生成模型',
      addFirstVisionModel: '添加第一个视觉模型',
      addModel: '添加模型',
      editModel: '编辑模型',
      deleteConfirm: '确定删除模型 {{name}} 吗？',
      deleteWarning: '删除后无法恢复，请谨慎操作',
      disableDefaultModelTitle: '禁用默认模型',
      disableDefaultModelContent:
        '模型 {{modelName}} 已被应用到默认模型配置中，禁用后需要重新配置默认模型，确定禁用吗？',
      deleteSyncConfirm:
        '模型 {{name}} 已被应用到默认模型配置中，删除后需要重新配置默认模型，确定删除吗？',
      disableSyncConfirm:
        '模型 {{name}} 已被应用到默认模型配置中，禁用后需要重新配置默认模型，确定禁用吗？',
      noMediaModels: '暂无媒体生成模型',
      noVisionModels: '暂无视觉模型',
      provider: '供应商',
      providerPlaceholder: '请选择供应商',
      name: '模型名称',
      namePlaceholder: '请输入模型名称',
      modelId: '模型ID',
      modelIdPlaceholder: '请设置模型ID',
      providerItem: '模型',
      providerItemPlaceholder: '请选择模型',
      enable: '启用',
      enabled: '是否启用',
      disable: '禁用',
      searchPlaceholder: '搜索模型',
      noSearchResults: '没有找到任何模型',
      noModels: '暂无模型',
      addFirstModel: '添加第一个模型',
      tryDifferentSearch: '尝试不同的搜索',
      reranker: '重排器',
      embedding: '嵌入',
      rerankerDescription: '用于重新排序搜索结果，提高准确性',
      embeddingDescription: '用于知识库搜索功能的必要组件',
      contextLimit: '上下文数量限制',
      contextLimitPlaceholder: '请设置上下文数量限制',
      maxOutput: '最大输出token',
      maxOutputPlaceholder: '请设置最大输出token',
      capabilities: '能力',
      capabilitiesPlaceholder: '请勾选能力',
      functionCall: '函数调用',
      visual: '视觉',
      reasoning: '推理',
      contextCaching: '上下文缓存',
      image: '图像',
      video: '视频',
      audio: '音频',
      batchSize: '批量大小',
      batchSizePlaceholder: '请设置批量大小',
      dimensions: '维度',
      dimensionsPlaceholder: '请设置维度',
      topN: '返回结果数量',
      topNPlaceholder: '请设置返回结果数量',
      relevanceThreshold: '相关性阈值',
      relevanceThresholdPlaceholder: '请设置相关性阈值',
      clickToSet: '点击设置',
      group: '分组名称',
      groupPlaceholder: '请设置分组名称，用于分类管理模型',
      default: '默认分组',
      providerMode: '配置模式',
      providerModeDescription: '全局模式将使用服务器配置的模型，自定义模式支持配置自有供应商的模型',
      custom: '自定义',
      global: '全局',
      syncSuccessfully: '配置模式更新成功！',
      syncFailed: '配置模式更新失败，请重试！',
      description: '描述',
      descriptionPlaceholder: '请输入模型的描述信息',
    },
    modelTier: {
      free: '免费',
      t1: '高级',
      t2: '标准',
    },
    parserConfig: {
      webSearch: '网页搜索',
      parserType: '解析类型',
      parserProvider: '解析供应商',
      urlParsing: 'URL 解析',
      pdfParsing: 'PDF 解析',
      searxng: 'SearxNG (内置)',
      cheerio: 'Cheerio (内置)',
      pdfjs: 'PDF.js (内置)',
      createProvider: '创建供应商',
      updateConfigSuccessfully: '配置更新成功！',
      updateConfigFailed: '配置更新失败，请重试！',
      settingPlaceholder: ' 未配置',
    },
    defaultModel: {
      title: '默认模型设置',
      chat: '默认问答模型',
      agent: '默认 Agent 模型',
      queryAnalysis: '问题分析与上下文处理',
      titleGeneration: '智能标题生成',
      image: '默认图像生成模型',
      video: '默认视频生成模型',
      audio: '默认音频生成模型',
      noModel: '未设置',
      updateSuccessfully: '更新成功！',
      syncSuccessfully: '默认模型配置同步更新成功！',
      updateFailed: '更新失败，请重试！',
      description: {
        chat: '当您没有指定具体模型时，我们将用这个模型为您解答问题。',
        agent: '当您开启 Agent 模式时，将会使用此模型。',
        queryAnalysis:
          '帮助更好地理解您的问题，同时优化处理输入的上下文内容（推荐使用处理速度快且经济的模型）。',
        titleGeneration: '为文档或画布自动生成合适的标题。',
        image: '用于生成图像、艺术作品和视觉内容的模型。',
        video: '用于生成视频、动画和动态图形的模型。',
        audio: '用于生成音频、音乐和音效的模型。',
      },
    },
  },
  invitationCode: {
    title: '输入邀请码以继续',
    description: '输入您的 6 位邀请码',
    dontHaveInvitationCode: '还没有邀请码？',
    reward: '已使用 +500积分',
  },
  contentDetail: {
    breadcrumb: {
      homePage: 'Home',
    },
    item: {
      share: '分享',
      copy: '复制链接',
      copyNotify: '链接已复制到剪贴板',
      copyContent: '复制内容',
      copySuccess: '内容已复制到剪贴板！',
      noMoreText: '已经到底啦~',
      askFollow: {
        emptyNotify: '追问内容不能为空！',
        successNotify: '创建会话成功！页面跳转中...',
        errorNotify: '创建会话失败！请重试',
        modal: {
          title: '确认创建会话',
          okText: '确认',
          cancelText: '取消',
          content: '确定之后会基于当前内容创建会话，并基于问题 {{question}} 生成追问',
        },
      },
      session: {
        content: '正文内容',
        source: '搜索结果',
        relatedQuestions: '相关问题',
      },
      webLink: {
        btnTip: '查看此网页的总结',
        text: '总结',
        summaryModal: {
          successNotify: '获取总结详情成功！',
          errorNotify: '获取总结详情失败，请重试！',
        },
      },
      input: {
        placeholder: '创建新会话并追问...',
        btnTip: '创建新会话并追问',
      },
    },
  },
  threadDetail: {
    header: {
      newThread: '新会话',
    },
    breadcrumb: {
      threadLibrary: '会话库',
    },
    empty: {
      title: '对话遇到点问题哦~ 暂无内容',
    },
    item: {
      share: '分享',
      copy: '复制链接',
      copyNotify: '链接已复制到剪贴板',
      copyAnswer: '复制答案',
      copySuccess: '答案已复制到剪贴板！',
      noMoreText: '已经到底啦~',
      askFollow: {
        btnText: '点击进行追问',
        emptyNotify: '追问内容不能为空！',
        successNotify: '创建会话成功！页面跳转中...',
        errorNotify: '创建会话失败！请重试',
        modal: {
          title: '确认创建会话',
          okText: '确认',
          cancelText: '取消',
          content: '确定之后会基于当前内容创建会话，并基于问题 {{question}} 生成追问',
        },
      },
      session: {
        answer: '答案',
        source: '搜索结果',
        relatedQuestions: '相关问题',
      },
      input: {
        placeholder: '继续提问...',
        selectedWeblink: {
          title: '基于选中网页提问：',
        },
        searchPlaceholder: {
          all: '对全部知识库进行提问...',
          selectedWeblink: '对选中的网页进行提问...',
          current: '对当前网页进行提问...',
          internet: '输入关键词进行网络搜索...',
          currentSelectedContent: '基于实时选择内容提问...',
        },
        status: {
          emptyNotify: '提问内容不能为空',
          contentHandling: '处理内容中...',
          createFailed: '创建新会话失败！',
          contentHandleSuccessNotify: '处理成功，正在跳转到会话页面...',
          contentHandleFailedNotify: '处理失败！',
        },
      },
    },
  },
  entitySelector: {
    placeholder: {
      project: '选择项目',
      resource: '选择资源',
      note: '选择画布',
      skill: '选择技能',
      conversation: '选择会话',
    },
    createEntity: {
      project: '新建项目',
      resource: '新建资源',
      note: '新建画布',
      skill: '新建技能',
      conversation: '新建会话',
      newProjectNameIsEmpty: '请输入项目名称',
    },
  },
  hooks: {
    useBuildThreadAndRun: {
      status: {
        createFailed: '创建新会话失败！',
      },
      task: {
        summary: {
          question: '总结网页',
          actionPrompt: '总结网页内容并提炼要点',
        },
      },
    },
  },
  components: {
    markdown: {
      parameters: '输入',
      result: '结果',
      failureReason: '失败原因',
      parameterName: '名称',
      parameterValue: '值',
      loadingToolCall: '加载工具调用详情...',
      noToolCallResult: '工具调用结果为空',
      copySuccess: '已复制到剪贴板',
      emptyCode: '无法创建空代码组件',
      codeArtifactCreated: '代码组件已创建',
      codeArtifactError: '创建代码组件时出错',
      viewCode: '查看代码',
      viewPreview: '查看预览',
      createCodeArtifact: '创建代码组件',
      collapse: '折叠',
      expand: '展开',
      collapsed: '已折叠',
      mermaidError: '渲染 Mermaid 图表时出错',
      mermaid: {
        copySourceSuccess: '源代码已复制到剪贴板',
        copySourceError: '复制源代码失败',
        copySuccess: '图表已复制到剪贴板',
        copyError: '复制图表失败',
        downloadSuccess: '图表下载成功',
        downloadError: '下载图表失败',
        copyStarted: '开始复制...',
        downloadStarted: '开始下载...',
        emptyCode: '无法创建空 Mermaid 组件',
        artifactCreated: 'Mermaid 图表组件已创建',
        artifactError: '创建 Mermaid 图表组件时出错',
        downloadAsPng: '下载为 PNG',
        copyToClipboard: '复制到剪贴板',
        copySourceCode: '复制源代码',
        createArtifact: '创建图表组件',
      },
      workflow: {
        generating: '生成工作流中...',
        invalidData: '无效的工作流数据',
        generateFailed: '生成工作流失败',
        patchFailed: '修改当前工作流失败',
      },
      internalTool: {
        readFile: '阅读',
        listFiles: '翻阅文件列表',
        copilotSummary: '阅读工作流摘要',
        readAgentResult: '阅读执行结果:',
        readToolResult: '阅读工具输出:',
      },
    },
    artifact: {
      webRender: '网页渲染',
      reactComponent: 'React组件',
      flowchart: '流程图',
      mindmap: '思维导图',
      markdown: 'Markdown',
      code: '代码',
      svgImage: 'SVG图像',
      notSelected: '未选择{type}组件',
      loading: '{type}加载中...',
      generating: '{type}生成中...',
    },
    image: {
      defaultTitle: '图片',
      notFound: '未找到图片资源',
    },
    nodeBlock: {
      untitledNode: '未命名节点',
      confirmDelete: '确认移除节点',
      confirmDeleteContent: '确定要移除此节点吗？此操作不可恢复。',
      deleteNode: '移除节点',
      wideModeView: '宽屏模式查看',
      slideshowPreview: '幻灯片预览',
    },
    nodeRenderer: {
      unsupportedComponent: '不支持的组件',
      onlyCodeComponentSupported: '仅支持代码组件类型',
    },
    preview: {
      unsupportedNodeType: '不支持的内容类型',
      navigationDirectory: '导航目录',
      slideshowPreview: '幻灯片预览',
      swipeToNavigate: '左右滑动切换幻灯片',
    },
    sidebar: {
      addNewSlideInDevelopment: '添加新代码组件功能开发中',
      noNavigationDirectory: '暂无导航目录',
    },
  },
  copilot: {
    title: '工作流助手',
    assistant: '助手',
    placeholder: '描述你想生成的工作流...',
    loadingWorkflow: '加载工作流中...',
    pureCopilotPlaceholder: '嗨，今天你想创建什么工作流？',
    samplePrompt: '示例提示词',
    header: {
      history: '历史会话',
      newConversation: '新建会话',
      close: '关闭',
    },
    greeting: {
      title: 'Hi，{{name}}',
      subtitle: '在寻找哪方面的灵感?',
      youCanTry: '获取新灵感',
      query1:
        '使用 Perplexity 查找十位制作过该产品相关视频的高浏览量 YouTube 创作者，进行分析和比较，并将报告通过电子邮件发送给我。',
      query2:
        '使用 Perplexity 获取昨天 Product Hunt 排行榜前五的产品，创建一份摘要文档和一集播客，并通过电子邮件发送给我。',
      query3:
        '帮我生成一个由五张图像组成的动画系列，采用新海诚的风格，主题为“成长”，并使用图像生成工具创建所有图像。',
    },
    sessionDetail: {
      thinking: '思考中',
      approve: '采纳',
      confirmClearCanvas: {
        title: '确认清空画布',
        content: '采纳此工作流将清空当前画布的所有内容。是否继续？',
        confirm: '继续',
        cancel: '取消',
      },
    },
    addContext: '添加上下文',
    moreSettings: '更多设置',
    baseContextCard: {
      title: '环境上下文快捷操作',
      filterTitle: '过滤环境上下文',
      resourceContextCard: {
        title: '当前资源快捷操作',
        summary: {
          prompt: '总结',
          title: '总结',
        },
        relatedResource: {
          prompt: '相似资源',
          title: '相似资源',
        },
      },
      noteContextCard: {
        title: '当前画布快捷操作',
        noteSelectedTitle: '选中画布内容问答',
        selectedContentCount: '（共 {{count}} 个）',
        noSelectedContent: '暂无选中内容...',
        improveWriting: {
          prompt: '以更适于写作的目的优化目标文本',
          title: '改进写作',
        },
        fixSpllingAndGrammar: {
          prompt: '修复拼写和语法错误',
          title: '修复拼写和语法错误',
        },
        makeShorter: {
          prompt: '缩短并精炼内容',
          title: '缩短内容',
        },
        makeLonger: {
          prompt: '扩写内容',
          title: '扩写内容',
        },
        changeTone: {
          prompt: '将选中内容修改为 {{tone}} 语气',
          itemList: {
            professional: '专业的',
            casual: '随意的',
            direct: '直接的',
            confident: '自信的',
            friendly: '友好的',
          },
          title: '修改语气',
        },
        simplifyLanguage: {
          prompt: '以一年级小学生能够听懂的形式保持语义不变的前提下简化这段内容',
          title: '简化语言',
        },
        summary: {
          prompt: '总结选中内容',
          title: '总结',
        },
        translate: {
          prompt: '将选中内容翻译为 {{language}} 语言',
          title: '翻译',
        },
        explainThis: {
          prompt: '解释选中内容',
          title: '解释',
        },
        findActionItem: {
          prompt: '提取待办事项',
          title: '提取代办事项',
        },
        continueWriting: {
          prompt: '基于当前上下文续写并将内容补充完整',
          title: '续写',
        },
        brainstormIdeas: {
          prompt: '脑暴想法',
          title: '脑暴想法',
        },
        blogPost: {
          prompt: '撰写博客文章',
          title: '撰写博客文章',
        },
        outline: {
          prompt: '撰写文章大纲',
          title: '撰写文章大纲',
        },
        socialMediaPost: {
          prompt: '撰写社交媒体文章',
          title: '撰写社交媒体文章',
        },
      },
    },
    selectedTextCard: {
      title: '选中内容快捷操作',
      filterTitle: '过滤选中上下文',
      placeholder: '暂无选中内容...',
      options: {
        resource: '选中资源内容',
        note: '选中画布内容',
        noteCursorSelection: '画布光标选中内容',
        noteBeforeCursorSelection: '画布光标前内容',
        noteAfterCursorSelection: '画布光标后内容',
        conversation: '选中会话内容',
      },
      save: {
        title: '保存',
        tooltip: '保存选中内容',
        successNotify: '保存成功！',
        errorNotify: '保存失败！',
      },
    },
    chatHistory: {
      title: '对话历史',
      empty: '未选中任何对话',
    },
    skillDisplay: {
      skillManager: '技能管理',
      manager: '管理',
      more: '更多',
    },
    chatInput: {
      placeholder: '让 AIMfly 帮你写点什么，或者搜索任何感兴趣的内容...',
      defaultQuestion: '[调用技能: {{name}}]',
      editPlaceholder: '让 AI 帮你编辑...',
      chatWithAIMflyAssistant: '和「知识管家」聊聊',
    },
    chatActions: {
      send: '发送',
      stop: '停止',
      directChat: '直接聊天',
      noContextChat: '不带上下文聊天',
      wholeSpaceChat: '在整个空间聊天',
      recommendQuestions: '推荐问题',
      chooseMcp: '选择 MCP',
      replace: '替换选中',
      reject: '拒绝',
      copy: '复制回答',
      discard: '放弃修改',
    },
    configManager: {
      title: '技能配置',
      errorTipTitle: '发送失败',
      errorTip: '请调整技能配置后再重试',
    },
    projectSelector: {
      title: '选择项目',
      tip: '所选项目将用于保存画布，若未选择将自动新建项目。',
    },
    webSearch: {
      title: '全网搜索',
      enable: '启用',
      disable: '禁用',
    },
    knowledgeBaseSearch: {
      title: '知识库搜索',
      enable: '启用',
      disable: '禁用',
    },
    deepReasonWebSearch: {
      title: '深度网页搜索',
      enable: '启用',
      disable: '禁用',
    },
    tokenUsage: '输入 {{inputCount}}，输出 {{outputCount}}',
    AIMflyAssistant: 'AIMfly 知识管家',
    message: {
      copy: '复制',
      copySuccess: '复制成功',
      insertBelow: '插入文档',
      replaceSelection: '替换选中',
      createDocument: '保存为新文档',
      createNewNote: '创建新文档',
      skillRunSuccess: '技能已完成，共 {{count}} 条日志',
      skillRunning: '技能运行中...',
      relatedQuestion: '推荐问题',
      askFollowingSuccess: '问题已添加到输入框',
      summarySelectedContent: '总结选中内容要点',
      brainstormIdeas: '脑暴写作灵感',
      writeTwitterArticle: '写一篇 Twitter 原创文章',
      installSkillHint: '你还未添加任何助手，点我添加',
      installSkillHintTitle: '添加助手',
      openCanvas: '打开画布',
    },
    abortConfirmModal: {
      title: '停止执行',
      content: '确定要停止当前执行吗？已消耗的积分将不会返还。',
      confirm: '停止执行',
      cancel: '取消',
    },
    abortSuccess: '已停止执行',
    recommendQuestions: {
      title: '推荐问题',
      refresh: '换一批',
      empty: '暂无推荐问题',
    },
    contextItem: {
      current: '当前',
      documentSelection: '文档选中',
      resourceSelection: '资源选中',
      selection: '已选中',
      skillResponseSelection: '技能响应选中',
      documentCursorSelection: '文档光标选中内容',
      documentBeforeCursorSelection: '文档光标前内容',
      documentAfterCursorSelection: '文档光标后内容',
      extensionWeblinkSelection: '网页选中',
      document: '文档',
      resource: '资源',
      memo: '备忘录',
      skillResponse: 'AI 回答',
      threadHistory: '对话历史',
      quote: '引用内容',
      extensionWeblink: '网页',
    },
    modelSelector: {
      configureModel: '点击配置模型',
      noVisionSupport: '该模型不支持消费图片',
      noAvailableModel: '无可用模型',
    },
    contentSelector: {
      openForWeb: '开启选择内容提问, 画布已进入只读模式',
      closeForWeb: '关闭选择器, 画布已恢复编辑',
      open: '已开启内容选择器',
      close: '已关闭内容选择器',
    },
    convListModal: {
      title: '会话库',
    },
    sourceListModal: {
      title: '结果来源',
      moreSources: '查看更多并导入画布',
      searchPlaceholder: '搜索来源...',
      openOriginWebsite: '打开来源链接',
      openKnowledgeBaseLink: '打开项目链接',
      webSearchTab: '全网搜索',
      libraryTab: '知识库搜索',
      noUrl: '该来源没有链接，可选中之后导入画布',
    },
    premiumBanner: {
      message: '需要更多使用次数？升级到高级版解锁更高限制。',
      upgrade: '升级方案',
    },
  },
  title: '欢迎 {{name}}，使用 react-i18next 完全类型安全的 React',
  description: {
    part1: '这是一个简单的例子。',
    part2: '😉',
  },
  userMessagesUnread_one: '您有 {{count}} 条未读消息。',
  userMessagesUnread_other: '您有 {{count}} 条未读消息。',
  requestAccess: {
    description: '哎呀，当前账号还没有内测资格',
    apply: '申请试用资格',
    copyEmail: '复制邮箱 ',
  },
  homePage: {
    suggestion: {
      investment: '写一篇投资 Memo',
      productSearch: '撰写竞品调研',
      academicArticle: '写一篇关于 Scaling law 的学术文章',
      socialTweet: '基于 Founder mode 撰写社交推文',
    },
    footer: {
      pricing: '定价',
      contact: '联系我们',
      terms: '条款',
      privacy: '隐私',
    },
  },
  tools: {
    title: '选择工具',
    empty: '暂无工具可用',
    selected: '已选择',
    browseToolStore: '去安装',
    manageTools: '管理工具',
    useTools: '使用工具',
  },
  pilot: {
    name: 'Agent',
    newTask: '新任务',
    description: 'AIMfly Agent 是一个自主 Agent，它通过在自由画布中显示思维步骤来解决您的问题。',
    thinking: 'Agent 正在思考',
    noSessions: '暂无会话',
    loadFailed: '加载会话失败',
    epoch: '第 {{count}} 轮',
    newSession: '新会话',
    sessionHistory: '会话历史',
    sessionInputPlaceholder: '问点什么...',
    createPilotSessionFailed: '创建会话失败',
    recentSessions: '最近会话',
    createdAt: '创建时间',
    noTasks: '暂无任务',
    status: {
      init: '初始化',
      executing: '运行中',
      waiting: '等待中',
      finish: '已完成',
      failed: '失败',
      planning: '正在规划任务...',
      executingSteps: '任务执行 {{current}} / {{total}} ...',
      completedTasks: '已完成{{count}}个任务 ...',
      taskFailed: '任务已终止',
      understandingIntent: '正在理解意图分析需求...',
    },
    recovery: {
      title: '重试所有失败任务',
      success: '会话恢复已成功启动',
      error: '恢复会话失败',
    },
    stepRecovery: {
      button: '重试',
      success: '步骤恢复已成功启动',
      error: {
        noStepId: '步骤ID不存在',
        general: '步骤恢复失败',
      },
    },
  },
  deck: {
    references: '引用',
    referencedBy: '被引用',
  },
  tour: {
    onboardingModal: {
      prev: '上一页',
      next: '下一页',
      startInteractive: '开始交互式教程',
      title: '功能亮点',
      highlight: {
        1: '多线程对话',
        2: 'AI 驱动的技能',
        3: '上下文',
        4: '知识库整合',
        5: '引文',
        6: 'AI 文档编辑',
        7: '帮助文档',
      },
      description: {
        1: 'AIMfly 采用创新的多线程对话机制，让您能够自由切换多个独立对话主题，实现更流畅自然的思维发散与深入探讨，有效突破传统对话的局限性。',
        2: '借助 AI 模型驱动，输入问题后，可灵活选取画布中的任一节点作为上下文，生成新的节点内容。',
        3: '为每次对话提供精确的临时知识库支持，确保AI模型能准确理解和回应您的问题。您可以灵活选择画布中的任意节点或添加引用作为上下文。',
        4: '支持导入多样化的外部资源，根据需求智能整合到画布中，构建完整的知识体系，打造个性化的思维空间。',
        5: '支持从各类资源、文档、备忘录或技能输出中灵活选取内容，一键添加为上下文引用，提升对话的准确性和深度。',
        6: '除提供强大的Markdown实时编辑功能外，支持智能选中文档内容，根据您的需求进行AI辅助的精准修改和润色。',
        7: 'AIMfly 提供丰富的帮助文档，帮助您快速上手 AIMfly, 点击画布左下角「帮助」按钮，查看更多帮助文档。',
      },
    },
  },
  template: {
    templateLibrary: '模板库',
    myTemplates: '我的模板',
    allTemplates: '全部',
    createTemplate: '发布模板',
    templateTitle: '名称',
    templateTitlePlaceholder: '请输入模板名称',
    templateDescription: '描述',
    templateDescriptionPlaceholder: '请输入模板描述',
    createSuccess: '模板创建成功, 请在模板库中查看',
    preview: '体验',
    use: '制作同款',
    duplicateCanvas: '再创作',
    canvasTitle: '名称',
    duplicateCanvasTitlePlaceholder: '请输入名称',
    moreTemplates: '更多模版',
    searchPlaceholder: '请输入关键词搜索模板',
    noRelatedTemplates: '暂无相关模板',
    hideTemplates: '隐藏模板',
    duplicateCanvasEntities: '复制该画布所包含的文档以及资源',
    noDescription: '暂无描述',
    emptyList: '暂无模版，快来发挥你的创造力，为社区贡献模版吧～',
    notFoundQuestion: '没有找到你需要的自动化工作流模板？',
    goToMarketplace: '前往市场',
  },
  workflowApp: {
    title: '名称',
    description: '描述',
    titlePlaceholder: '请输入名称',
    descriptionPlaceholder: '请输入描述',
    publish: '发布',
    updatePublish: '更新发布',
    edit: '编辑应用',
    publishSuccess: '发布成功',
    alreadyPublished: '已发布',
    viewPublished: '查看已发布',
    runLogs: '运行日志',
    products: '结果产物',
    productsGenerated: '已为你生成 {{count}} 个结果',
    productsGeneratedWithCost: '已为你生成 {{count}} 个结果，使用 {{executionCost}} 积分',
    emptyLogs: '暂无运行日志，点击创建应用，开始运行',
    coverImage: '封面图片',
    coverImageHint: '支持 JPG、PNG、WebP 格式，文件大小 30MB 以内',
    uploadCover: '上传封面',
    invalidImageType: '图片格式不正确，请上传 JPG、PNG 或 WebP 格式的图片',
    imageTooLarge: '图片大小超过 30MB，请上传更小的图片',
    coverImageRequired: '封面图片为必填项',
    enableRemix: '启用 Remix',
    remixHint: '允许其他人Remix和修改此工作流应用',
    runResult: '运行结果',
    changeResult: '更换结果',
    resultsSelected: '个结果已选择',
    selectResults: '选择结果',
    noResultsAvailable: '暂无可用结果',
    noResultsSelected: '暂无选择结果',
    runResultRequired: '未选择运行结果。请在发布前选择结果。',
    validationNoUserInputs: '请在发布模板前添加输入项。',
    validationNoAgents: '请在发布模板前添加 Agent 节点。',
    validationAgentsNotRun: '请在发布模板前确保所有 Agent 节点运行成功。',
    validationRequiredInputsEmpty: '请在发布前填写所有必填输入项。',
    confirmCloseContent: '关闭后未保存的内容将丢失，确定要关闭吗？',
    resultPreview: '产物预览',
    notLoggedIn: '未登录',
    run: {
      completed: '模板运行成功',
      failed: '模板运行失败',
      error: '模板运行失败',
      loginRequired: '请登录以运行此工作流',
      loginRequiredCopy: '请登录以复制此工作流',
      workflowStarted: '工作流已启动',
      executionIdFailed: '获取执行 ID 失败',
      executeFailed: '执行工作流失败',
      executeError: '执行工作流失败',
      thinking: '思考中...',
      stop: '停止',
      stopped: '工作流已停止',
      stoppedMessage: '停止运行，未生成结果，可重新运行模板',
      stopConfirmTitle: '停止模板运行？',
      stopConfirmMain: '确认停止模板运行吗？',
      stopConfirmNote: '运行将立即终止，已消耗的积分不会退还。',
      stopSuccess: '模板运行已成功停止。',
      confirm: '确定停止',
      defaultAgentTitle: '智能体',
    },
    revenueSharing: {
      title: '模板被运行可享受积分收益分成',
      earningsHint: '预计模板每次运行可获得 <num>{{creditEarningsPerRun}}</num> 积分',
      howToEarn: '如何获得收益',
    },
    publishToCommunity: {
      label: '发布到市场',
      help: '发布到市场后，其他用户可以在市场中发现和使用你的工作流应用',
    },
    copyLinkTooltip: '复制最新发布版本的链接',
  },
  project: {
    create: '创建知识库',
    viewAllProjects: '查看所有知识库',
    addSource: '添加文件',
    canvas: '画布',
    source: '文件',
    noDescription: '快来填写描述吧～',
    customInstructions: '预设提示词',
    waitingUploadCover: '暂未上传封面',
    askProject: '知识库提问',
    noProjects: '暂无知识库',
    knowledgeToggle: {
      enabledDesc:
        '基于知识库提问当前被设置为开启，"{{projectName}}"内的文件知识会在提问时作为参考内容使用',
      disabledDesc:
        '基于知识库提问当前被设置为关闭，"{{projectName}}"内的文件知识不会在提问时作为参考内容使用',
    },
    selectProject: '选择知识库',
    switchProject: '切换知识库',
    createModal: {
      createTitle: '创建知识库',
      editTitle: '编辑知识库',
      title: '名称',
      titlePlaceholder: '请输入知识库名称',
      description: '描述',
      descriptionPlaceholder: '请输入知识库描述',
      cropCoverPicture: '裁剪封面图片',
      coverPicture: '封面',
      onlyImageAllowed: '只允许上传 PNG, JPG, JPEG, GIF 类型的图片',
      imageSizeLimited: '图片大小限制为 {{size}} MB',
      uploadCoverPicture: '上传封面',
      instructions: '预设提示词',
      instructionsPlaceholder: '请输入提示词',
    },
    action: {
      deleteSuccess: '删除成功',
      deleteConfirm: '确定删除知识库 "{{name}}" 吗？',
      createSuccess: '创建成功',
      editSuccess: '编辑成功',
      removeItemsSuccess: '已移除所选项',
      deleteItemsSuccess: '已删除所选项',
      addCanvas: '添加画布',
      createCanvas: '新建画布',
      addExistingCanvas: '添加已有画布',
      delete: '删除',
      remove: '从知识库移除',
      addToCanvas: '添加到画布',
      exit: '退出操作',
      addSource: '添加文件',
      addExistingSource: '添加已有文件',
      importResource: '导入资源',
      onlyImageAllowed: '只允许上传 {{type}} 类型的图片',
      imageSizeLimited: '图片大小限制为 {{size}} MB',
    },
    addSources: {
      title: '添加文件',
      selectAll: '全选',
    },
    sourceList: {
      selectedCount: '已选择 {{count}} 项',
      removeConfirm: '确定从当前知识库中移除所选项吗？',
      deleteConfirm: '所选 {{count}} 项将被永久删除，是否要继续？',
      searchPlaceholder: '输入关键词搜索...',
      sourceCount: '{{resourceCount}} 个资源 · {{documentCount}} 个文档',
    },
    canvasCount: '{{canvasCount}} 个画布',
  },
  pages: {
    share: {
      sharedAt: '分享于',
      slideshow: '幻灯片预览',
      noContent: '暂无内容',
      noContentDesc: '该分享页面没有任何内容',
      loadingContent: '加载中...',
      loadFailed: '加载页面失败',
      loadFailedDesc: '请检查网络连接或稍后再试',
      pageNotExist: '页面不存在',
      pageNotExistDesc: '请检查URL或返回页面列表',
      returnToList: '返回列表',
      wideModeLoadFailed: '宽屏模式加载内容失败',
      navigationDirectory: '导航目录',
      swipeHint: '左右滑动切换幻灯片',
      invalidShareLink: '无效的分享链接',
      expiredShareLink: '此分享链接可能已过期或不存在',
    },
    edit: {
      savePage: '保存页面',
      saving: '保存中...',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      back: '返回',
      titlePlaceholder: '输入页面标题',
      descriptionPlaceholder: '输入页面描述（可选）',
      noContent: '暂无内容',
      noContentDesc: '此页面还没有任何内容',
      addContent: '添加内容',
      deleteNodeConfirm: '确定要删除此节点吗？',
      deleteNodeSuccess: '节点删除成功',
      deleteNodeFailed: '节点删除失败',
      shareLink: '链接分享',
      whoCanView: '谁可以查看此页面',
      internetUsers: '互联网获得链接的人',
      notEnabled: '未开启',
      copyShareLink: '复制分享链接',
      shareUrl: '分享链接',
      copied: '已复制',
      copy: '复制',
      shareUrlDesc: '获得此链接的人均可查看此页面内容',
      sharing: '分享中...',
      shareSuccess: '分享成功',
      shareFailed: '分享失败',
      preview: '预览',
      loading: '加载中...',
      loadFailed: '加载页面失败',
      loadFailedDesc: '请稍后再试',
      noPage: '页面不存在',
      noPageDesc: '您查找的页面不存在',
      returnToList: '返回列表',
    },
    components: {
      navigationDirectory: '导航目录',
      swipeHint: '左右滑动切换幻灯片 ({current}/{total})',
      codeComponent: '代码组件',
      documentComponent: '文档组件',
      artifact: {
        notSelected: '未选择组件',
        loading: '加载中...',
        generating: '生成中...',
        code: '代码',
        fixCodeNeeded: '需要修复代码',
      },
      skillResponse: {
        notSelected: '未选择技能响应组件',
      },
      slide: '幻灯片 {index}',
      nodeBlock: {
        untitledNode: '未命名节点',
        confirmDelete: '确认移除节点',
        confirmDeleteContent: '确定要移除此节点吗？此操作不可恢复。',
        deleteNode: '移除节点',
        wideModeView: '宽屏模式查看',
        slideshowPreview: '幻灯片预览',
      },
    },
    list: {
      fetchFailed: '获取页面列表失败',
      shareSuccess: '分享成功，链接已复制到剪贴板',
      shareFailed: '分享页面失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除页面失败',
      title: '标题',
      status: '状态',
      statusDraft: '草稿',
      statusPublished: '已发布',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      actions: '操作',
      edit: '编辑',
      share: '分享',
      delete: '删除',
      confirmDelete: '确定要删除这个页面吗?',
      myPages: '我的页面',
      createPage: '创建页面',
      noPages: '暂无页面',
    },
    new: {
      createPageFromCanvas: '从Canvas创建页面',
      pageTitle: '页面标题',
      optional: '可选',
      enterPageTitle: '输入页面标题',
      enterCanvasId: '输入Canvas ID',
      loadNodes: '加载节点',
      selectNodesToInclude: '选择要包含的节点',
      untitled: '无标题',
      type: '类型',
      selectAll: '全选',
      deselectAll: '取消全选',
      createPage: '创建页面',
      instructions: '使用说明',
      instructionStep1: '输入画布ID并点击"加载节点"按钮',
      instructionStep2: '从列表中选择您想包含在页面中的节点',
      instructionStep3: '输入页面标题（可选）',
      instructionStep4: '点击"创建页面"按钮',
      instructionStep5: '成功后，您将被重定向到页面列表',
      createPageFailed: '创建页面失败',
      noValidNodes: '未找到有效的节点数据',
      noNodesFound:
        '画布中没有找到可用的节点数据，幻灯片可加入的节点类型包含：文档、资源、技能响应、引用备忘录、网页、小组件，请先在画布中创建可用的节点',
      invalidApiResponse: 'API响应格式不符合预期',
      fetchCanvasDataFailed: '获取画布数据失败',
      pleaseEnterCanvasId: '请输入画布ID',
      pleaseSelectAtLeastOneNode: '请至少选择一个节点',
      untitledPage: '未命名页面',
      createdFromCanvas: '从画布 {canvasId}创建',
      pageCreatedSuccess: '页面创建成功',
      pageId: '页面ID',
      unknown: '未知',
      refresh: '刷新节点',
    },
    slideshow: {
      title: '幻灯片',
      newSlide: '点击创建幻灯片',
      newSlideDescription: '没有幻灯片？点击创建一个',
    },
  },
  credit: {
    balance: {
      title: '积分余额',
      loadFailed: '加载失败',
      loadFailedDesc: '无法获取积分余额信息，请稍后重试',
      availableCredits: '可用积分',
      totalRechargedCredits: '总充值积分',
      creditsUnit: '积分',
      dataInconsistent: '数据不一致，请检查',
      mockMode: '模拟',
      refreshData: '刷新数据',
      dataInconsistentWarning: '数据不一致警告',
      dataInconsistentDesc:
        '计算值与API返回值不匹配：计算总额={{calculatedAmount}}，API总额={{creditAmount}}；计算余额={{calculatedBalance}}，API余额={{creditBalance}}',
      calculationDetails: '积分计算详情',
      rechargeRecords: '条充值记录',
      calculationFormula: '计算公式',
      usedCredits: '已使用积分',
      calculationProcess: '计算过程',
      rechargeRecordsDetails: '充值记录明细',
      total: '合计',
      usageRate: '使用率',
      dataVerification: '数据验证',
      apiTotalRechargedCredits: 'API总充值积分',
      calculatedTotalRechargedCredits: '计算总充值积分',
      apiAvailableCredits: 'API可用积分',
      calculatedAvailableCredits: '计算可用积分',
      dataConsistency: '数据一致性',
      consistent: '一致',
      inconsistent: '不一致',
      creditExplanation: '积分说明',
      mockModeData: '模拟模式数据',
      realApiData: '真实API数据',
      explanationAvailable: '可用积分：当前可以使用的积分数量（充值记录余额总和）',
      explanationTotal: '总充值积分：历史累计充值的积分总额（充值记录金额总和）',
      explanationFifo: '积分按FIFO原则消耗（先进先出，最早充值的先被使用）',
      explanationExpiry: '积分充值后有效期为30天，过期后自动失效',
      expectedBalance: '当前测试用户预期余额: {{balance}} 积分',
      debugApiData: 'API数据',
      debugCalculatedData: '计算数据',
      debugRechargeCount: '充值记录数',
      debugMockMode: '模拟模式',
      debugCurrentUser: '当前用户',
      debugDataConsistency: '数据一致性',
      notSelected: '未选择',
      rechargeId: '充值ID',
      rechargeAmount: '充值金额',
      remainingBalance: '剩余余额',
      source: '来源',
      description: '描述',
      createdAt: '创建时间',
    },
    recharge: {
      title: '充值记录',
      loadFailed: '加载失败',
      loadFailedDesc: '无法获取充值记录信息，请稍后重试',
      reload: '重新加载数据',
      totalRecords: '条',
      reloadData: '刷新数据',
      status: {
        unused: '未使用',
        partial: '部分使用',
        depleted: '已耗尽',
      },
      columns: {
        rechargeId: '充值ID',
        amount: '充值金额',
        balance: '剩余余额',
        used: '已用',
        usage: '使用情况',
        source: '来源',
        description: '描述',
        createdAt: '创建时间',
        expiresAt: '到期时间',
      },
      unit: {
        credit: '积分',
      },
      stats: {
        overview: '充值统计概览',
        totalAmount: '总充值金额',
        remainingBalance: '剩余余额',
        usedCredit: '已使用积分',
        usageRate: '使用率',
        bySource: '按来源统计',
        times: '次',
        usageStatus: '使用状态统计',
        records: '条',
      },
      totalRecordsRange: '第 {{start}}-{{end}} 条，共 {{total}} 条记录',
      currentPageTotal: '当前页合计',
      currentPageUsed: '已用',
      pageUsageRate: '页面使用率: {{rate}}%',
      dataExplanation: '数据说明',
      'dataExplanation.amount': '充值金额',
      'dataExplanation.amountDesc': '每次充值的原始积分数量',
      'dataExplanation.balance': '剩余余额',
      'dataExplanation.balanceDesc': '该笔充值记录的当前可用积分',
      'dataExplanation.usage': '使用情况',
      'dataExplanation.usageDesc': '该笔充值的积分消耗状态和百分比',
      'dataExplanation.fifo': 'FIFO原则',
      'dataExplanation.fifoDesc': '积分按先进先出顺序消耗，最早充值的先被使用',
      'dataExplanation.validity': '有效期',
      'dataExplanation.validityDesc': '充值后30天内有效，过期后自动失效',
    },
    usage: {
      title: '使用记录',
      loadFailed: '加载失败',
      loadFailedDesc: '无法获取使用记录信息，请稍后重试',
      reload: '重新加载数据',
      records: '条',
      refresh: '刷新数据',
      points: '积分',
      times: '次',
      usageId: '使用ID',
      amount: '积分消耗',
      usageType: '使用类型',
      modelName: '模型名称',
      description: '描述',
      pilotSessionId: '会话ID',
      createdAt: '使用时间',
      overview: '使用统计概览',
      totalUsage: '总消耗积分',
      usageCount: '使用次数',
      averageUsage: '平均消耗',
      maxSingleUsage: '最大单次消耗',
      byType: '按使用类型统计',
      popularModels: '热门模型 (Top 5)',
      recentTrend: '最近7天使用趋势',
      pageTotal: '第 {{start}}-{{end}} 条，共 {{total}} 条记录',
      currentPageTotal: '当前页合计',
      pageAverage: '页面平均: {{average}} 积分/次',
      dataDescription: '数据说明',
      pointsConsumed: '积分消耗',
      pointsConsumedDesc: '每次操作消耗的积分数量',
      usageTypeDesc: 'AI操作的分类（模型调用、媒体生成等）',
      modelNameDesc: '具体使用的AI模型标识',
      fifoDeduction: 'FIFO扣减',
      fifoDeductionDesc: '积分按充值时间先进先出的顺序扣减',
      realTimeRecord: '实时记录',
      realTimeRecordDesc: '每次AI操作完成后立即记录积分消耗',
    },
    test: {
      pageTitle: '积分系统测试页面',
      pageDescription: '完整的积分功能测试界面，支持多用户场景验证和实时数据查看',
      userSelector: '测试用户选择器',
      quickTestTitle: '快速测试说明',
      quickTestDescription:
        '选择不同的测试用户来验证各种积分场景。可以直接切换查看数据，或者点击登录按钮实际登录该用户。',
      selectTestUser: '选择测试用户',
      selectUserPlaceholder: '选择测试用户',
      expectedBalance: '预期余额',
      actualLogin: '实际登录',
      simulationMode: '模拟模式',
      currentMode: '当前模式',
      simulation: '模拟模式',
      realMode: '实际模式',
      simulationDescription: '模拟模式：快速切换不同用户数据，适合UI测试',
      realModeDescription: '实际模式：真实API调用和登录验证',
      selectedUser: '选中用户',
      userName: '用户名',
      userId: '用户ID',
      scenario: '测试场景',
      testingInfo: '测试信息',
      apiEndpoints: 'API接口',
      testUsers: '测试用户',
      testScenarios: '测试场景',
      testModes: '测试模式',
      coreFeatures: '核心功能',
      feature1: '积分余额查询：实时显示用户可用积分和总充值积分',
      feature2: '充值记录管理：查看历史充值信息、来源、有效期等',
      feature3: '使用记录分析：详细的积分消费记录和使用统计',
      feature4: '数据一致性验证：对比计算值与API返回值',
      testingFeatures: '测试功能',
      testFeature1: '多用户场景测试：支持不同积分状态的用户',
      testFeature2: '模拟和实际模式：快速切换与真实API调用',
      testFeature3: '实时数据刷新：手动刷新和自动更新',
      testFeature4: '调试信息展示：详细的数据对比和一致性检查',
      usageSuggestion: '使用建议',
      usageSuggestionDesc:
        '首次测试建议使用"实际登录模式"验证API功能，然后使用"模拟模式"快速切换不同用户场景进行UI测试。',
      detailedTestPlan: '详细测试方案',
      apiDocs: 'API 文档',
      projectRepo: '项目仓库',
      switchingUser: '正在切换到用户: {{userName}}...',
      switchUserSuccess: '✅ 已切换到用户: {{userName}}，数据已刷新',
      loggingIn: '正在登录测试用户...',
      loginSuccess: '✅ 成功登录: {{userName}}，数据已刷新',
      loginFailed: '❌ 登录失败，请检查网络或服务器状态',
      loginError: '❌ 登录过程中发生错误',
    },
  },
  workflowList: {
    title: '工作流',
    createWorkflow: '创建工作流',
    creatYourWorkflow: '创建你的工作流',
    noWorkflows: '暂无工作流',
    noSearchResults: '没有找到相关工作流',
    searchWorkflows: '搜索工作流',
    shared: '已分享',
    private: '私有',
    published: '已发布',
    unpublished: '未发布',
    share: '分享',
    unshare: '取消分享',
    copyLink: '复制工作流链接',
    copyLinkTooltip: '请先设置为公开可见后再分享',
    templateLink: '复制模板链接',
    templateLinkCopied: '模板链接复制成功，粘贴到浏览器即可查看',
    templateNotPublishedTooltip: '模板未发布，发布后即可查看详情',
    templateLinkFailed: '复制工作流 {{title}} 模板链接失败',
    shareSuccess: '工作流 {{title}} 分享成功！链接已复制到剪贴板。',
    shareFailed: '分享工作流 {{title}} 失败',
    unshareSuccess: '{{title}} 已取消分享',
    unshareFailed: '取消分享 {{title}} 失败',
    copyLinkSuccess: '链接复制成功！分享你的工作流给好友试试吧',
    copyLinkFailed: '复制工作流 {{title}} 链接失败',
    usedToolsetsTitle: '工作流工具',
    tableTitle: {
      workflowName: '标题',
      status: '状态',
      publishStatus: '发布状态',
      tools: '工具',
      schedule: '定时任务',
      owner: '创建人',
      lastModified: '更新时间',
      actions: '操作',
    },
    filters: {
      hasSchedule: '定时任务',
    },
  },
  schedule: {
    title: '定时任务',
    createTitle: '创建定时任务',
    editTitle: '编辑定时任务',
    editSchedule: '编辑定时任务',
    name: '名称',
    namePlaceholder: '输入定时任务名称',
    nameRequired: '请输入名称',
    enabled: '启用',
    frequency: '频率',
    hourly: '每小时',
    daily: '每日',
    weekly: '每周',
    monthly: '每月',
    status: {
      on: '开',
      off: '关',
      error: '异常',
    },
    weekdays: '星期',
    selectWeekdays: '选择星期',
    weekdaysRequired: '请至少选择一天',
    monthDays: '日期',
    selectMonthDays: '选择日期',
    monthDaysRequired: '请至少选择一天',
    selectHours: '选择小时间隔',
    hourlyOptions: {
      interval: '每{{hours}}小时',
    },
    time: '时间',
    timeRequired: '请选择时间',
    timezone: '时区',
    selectTimezone: '选择时区',
    nextRun: '下次运行',
    cost: '成本',
    perRun: '每次运行',
    viewHistory: '查看历史',
    saveSuccess: '定时任务保存成功',
    dependencyError: '定时任务设置成功，但工作流存在问题待修复',
    createSuccess: '定时任务创建成功',
    updateSuccess: '定时任务更新成功',
    deleteSuccess: '定时任务删除成功',
    deactivateSuccess: '定时任务停用成功',
    deactivateError: '定时任务停用失败',
    saveFailed: '保存定时任务失败',
    deleteFailed: '删除定时任务失败',
    viewSchedules: '查看定时任务',
    limitReached: {
      title: '定时任务数量已达上限',
      message:
        '您已达到当前套餐的定时任务数量上限。您可以管理或禁用现有的定时任务以创建新的定时任务。',
    },
    weekday: {
      mon: '周一',
      tue: '周二',
      wed: '周三',
      thu: '周四',
      fri: '周五',
      sat: '周六',
      sun: '周日',
    },
    selectDate: '选择日期',
    runNow: '立即运行',
    triggerSuccess: '定时任务已触发',
    triggerFailed: '触发定时任务失败',
    noSchedule: '请先保存定时任务',
    deactivate: {
      title: '停用定时任务',
      message: '确定要停用该定时任务吗？该定时任务将不再自动运行，直到您再次启用它。',
      confirm: '停用',
      cancel: '取消',
      deactivate: '停用',
    },
  },
  runHistory: {
    pageTitle: '运行历史',
    title: '运行历史',
    searchPlaceholder: '搜索运行记录...',
    noRuns: '暂无运行记录',
    noSearchResults: '未找到相关记录',
    credit: '积分',
    viewDetail: '查看详情',
    runDetail: '运行详情',
    tableTitle: {
      title: '标题',
      type: '类型',
      time: '时间',
      tools: '工具',
      status: '状态',
      cost: '消耗',
      actions: '操作',
    },
    type: {
      all: '所有类型',
      workflow: '工作流运行',
      template: '模版运行',
      schedule: '定时任务运行',
    },
    status: {
      all: '所有状态',
      scheduled: '已计划',
      queued: '排队中',
      processing: '处理中',
      running: '执行中',
      succeeded: '成功',
      failed: '失败',
    },
    filters: {
      type: '类型',
      typeAll: '所有类型',
      typeWorkflow: '工作流运行',
      typeTemplate: '模版运行',
      typeSchedule: '定时运行',
      typeApi: 'API 触发',
      tools: '工具',
      state: '状态',
      allTools: '所有工具',
      selectTools: '选择工具',
      toolsSelected: '已选择 {{count}} 个工具',
      searchTools: '搜索工具',
      noTools: '暂无工具',
      clearAllTools: '清除所有选择',
      tool: '工具',
      title: '标题',
    },
    triggerNow: '立即触发',
    triggerSuccess: '触发成功',
    triggerError: {
      noScheduleId: '无法触发：缺少调度ID',
      failed: '触发失败，请稍后重试',
    },
    retry: '重试',
    retrySuccess: '重试成功',
    retryError: {
      noScheduleRecordId: '无法重试：缺少执行记录ID',
      failed: '重试失败，请稍后重试',
    },
  },
  runDetail: {
    pageTitle: '运行详情',
    title: '运行详情',
    backToHistory: '返回运行历史',
    loading: '加载运行详情中...',
    notFound: '未找到运行记录',
    time: '时间',
    cost: '消耗',
    creditUnit: '积分',
    status: '状态',
    triggeredAt: '触发时间',
    completedAt: '完成时间',
    creditUsed: '消耗积分',
    failureReason: '失败原因',
    statusDisplay: {
      succeeded: '运行成功',
      failed: '运行失败',
      running: '运行中',
    },
    failureReasons: {
      scheduleLimited: '数量超限',
      insufficientCredits: '积分不足',
      runFailed: '运行失败',
    },
    failureActions: {
      upgrade: '升级',
      viewSchedule: '查看定时',
      buyCredits: '购买积分',
      fixWorkflow: '修复原工作流',
      workflowDeleted: '原工作流已删除，无法查看',
    },
    actions: {
      duplicate: '基于此次运行再创作',
    },
    duplicateSuccess: '工作流复制成功',
    duplicateFailed: '工作流复制失败',
    noSnapshot: '暂无快照数据',
  },
  appManager: {
    title: '我的模版',
    searchApps: '搜索模版',
    noApps: '暂无模版',
    unpublish: '取消发布',
    view: '详情',
    noSearchResults: '没有找到相关模版',
    unpublishSuccess: '{{title}} 取消发布成功',
    unpublishFailed: '{{title}} 取消发布失败',
    deleteConfirm: '确定要撤销模版{{title}}吗',
    reviewStatus: {
      reviewing: '审核中',
      reviewingTooltip: '模板正在审核中,但仍可正常使用',
      published: '已发布',
      publishedTooltip: '模板已发布到社区',
    },
    upgradeSubscription: '升级订阅',
    updateTime: '更新时间',
  },
  whyChooseAIMfly: {
    title: '为什么选择 AIMfly 构建 Workflow？',
    features: {
      everyoneCanUse: {
        title: '人人可用',
        description: '零代码上手，非技术用户也能\n轻松搭建并运行完整工作流。',
      },
      configureOnce: {
        title: '一次配置，反复使用',
        description: '模板一键运行，避免重复设置，\n节省时间与精力。',
      },
      contextPreserved: {
        title: '上下文不丢失',
        description: '全局 Memory / Knowledge\n让输出结果稳定、可控、可复现。',
      },
      directDelivery: {
        title: '直接交付',
        description: '生成的不是中间结果，\n而是可直接使用的成品。',
      },
      distributable: {
        title: '可分发可变现',
        description: '将你的流程打包成作品，\n分享、售卖、形成持续增长飞轮。',
      },
      moreFeatures: {
        title: '更多精彩，等你发现',
        description: '',
      },
    },
  },
  environmentBanner: {
    test: '当前为测试环境，功能可能不稳定。',
    staging: '当前为预发布环境，请谨慎使用。',
  },
  filePreview: {
    contentTruncated: '仅显示前 {{maxLines}} 行。\n下载文件以查看完整内容。',
  },
  cliAuth: {
    title: '授权 CLI',
    subtitle: '授权你的 CLI 访问你的 AIMfly 账户。',
    loadingDevice: '正在加载设备信息...',
    checkingSession: '正在检查登录状态...',
    deviceId: '设备 ID',
    cliVersion: 'CLI 版本',
    host: '设备',
    permissionSummary: 'AIMfly AI CLI 将能够：',
    permissionItem1: '创建和更新工作流',
    permissionItem2: '运行工作流并消耗额度',
    permissionItem3: '访问你授权的工具和数据',
    loginRequired: '请先登录以授权此设备。',
    loginButton: '登录以继续',
    loggedInAs: '当前登录账户',
    authorizeButton: '授权',
    authorizedButton: '已授权',
    cancelButton: '取消',
    cancelHint: '如果你没有发起此 CLI 登录请求，请点击取消。',
    authorizing: '正在授权...',
    authorizedMessage: '授权成功。返回终端...',
    successTitle: '授权成功',
    successMessage: '你已成功授权此设备。',
    autoCloseCountdown: '{{seconds}} 秒后自动关闭页面',
    cancelledTitle: '链接已过期',
    cancelledMessage: '授权已取消，未授予访问权限',
    closeWindow: '关闭窗口',
    errorTitle: '授权错误',
    errorHint: '请重新运行 `AIMfly init` 以发起新的授权请求。',
    securityNote: '仅授权你信任的设备。该设备将能够访问你的 AIMfly 账户。',
    errors: {
      missingDeviceId: '缺少设备 ID。请使用 CLI 提供的链接。',
      invalidDevice: '无效或已过期的设备请求。',
      expiredDevice: '此授权请求已过期。请重新运行 `AIMfly init`。',
      authorizeFailed: '设备授权失败，请重试。',
      invalidVerificationCode: '验证码错误，请重新输入。',
    },
    verificationCodeLabel: '验证码',
    verificationCodePlaceholder: '输入 6 位验证码',
    verificationCodeHint: '请输入终端显示的 6 位数字验证码',
    copied: '已复制!',
  },
  toolInstall: {
    title: '安装所需工具',
    description: '安装并授权此工作流所需的工具。',
    noUnauthorizedTools: '已安装所有必需工具。',
    invalidWorkflow: '无效的工作流 ID。',
    referencedNodes: '相关节点',
    authorizeTitle: '授权工具',
    authorizeSubtitle: '要运行此技能，您需要连接 {{count}} 个工具',
    workflowToolsTitle: '授权工具',
    workflowToolsSubtitle: '此工作流使用了 {{count}} 个工具，请安装所需工具。',
    allToolsNeedInstall: '要运行此技能，你需要连接 {{count}} 个工具',
    partialToolsInstalled: '连接 {{installed}}/{{total}} 个工具以运行技能',
    allToolsInstalled: '全部设置完成！返回终端运行此技能',
    noTools: '此工作流中未找到工具。',
    connect: '连接',
    connected: '已连接',
  },
};

export default translations;
